import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
    en: {
        translation: {
            navbar: {
                home: 'Home',
                aboutUs: 'About Us',
                resort: 'Resort',
                ayurvedaWellness: 'Ayurveda Wellness',
                packages: 'Packages',
                contactUs: 'Contact Us',
            },
            language: {
                english: 'English',
                german: 'German',
                russian: 'Russian',
                french: 'French',
                chinese: 'Chinese',
                japanese: 'Japanese',
            },
            villa: {
                title: 'Sun Flower Beach Resort',
                description1: 'Nestled along the golden shores of Sri Lanka, Sun Flower Beach Resort offers a serene escape where the sound of the waves meets luxurious comfort. Our spacious luxury rooms feature modern amenities and breathtaking beach views, blending contemporary elegance with the charm of coastal living for an unforgettable stay.',
                description2: 'Guests can indulge in authentic Ayurveda treatments, enjoy world-class dining with fresh local flavors, and relax in an atmosphere designed for pure comfort. Whether you’re seeking a peaceful retreat, a romantic getaway, or a beachside adventure, Sun Flower Beach Resort is the perfect destination to fulfill your every desire.',
                imageAlt: 'Sun Flower Beach Resort view',
                roomsTitle: 'Our Deluxe Double Rooms',
                roomsDescription: 'Experience luxury and comfort in our exquisitely designed beach-view rooms at Sun Flower Beach Resort. Whether you’re traveling solo, as a couple, or with family, we offer the perfect luxury accommodation to make your seaside escape truly unforgettable.',
                singleRoomTitle: 'Deluxe Double Rooms',
                singleRoomAlt: 'Deluxe Double Room view',
                familyRoomTitle: 'Deluxe Double Room with Sea View',
                familyRoomAlt: 'Deluxe Double Room with Sea View',
                viewDetails: 'View Details',
                seaBathTitle: 'Front Sea View in The Resort',
                seaBathDescription1: 'Step outside Sun Flower Beach Resort and you’ll be greeted by the golden sands and crystal-clear waters of the Indian Ocean, just a few steps from your room. Whether you’re in the mood for a refreshing swim, a peaceful walk along the shore, or simply soaking up the sun, our beachfront location offers the perfect escape.',
                seaBathDescription2: 'With gentle waves, breathtaking ocean views, and the sound of the sea as your soundtrack, every moment here feels like paradise. Enjoy romantic sunset walks, indulge in beachfront dining under the stars, or try exciting water sports for a splash of adventure — all right at your doorstep at Sun Flower Beach Resort.',
                seaBathAlt: 'Sea view near Sun Flower Beach Resort',
                restaurantTitle: 'Our Restaurant',
                restaurantDescription1: 'Overlooking the golden shores of Sri Lanka, Sun Flower Beach Restaurant offers a delightful dining experience where the gentle sound of the waves complements exceptional cuisine. Our inviting beachfront setting combines the beauty of the ocean with warm hospitality, creating the perfect place to savor every bite.',
                restaurantDescription2: 'Guests can enjoy freshly prepared seafood, authentic Sri Lankan flavors, and international dishes crafted with the finest local ingredients. Whether you’re here for a romantic dinner, a family gathering, or a relaxing beachside meal, Sun Flower Beach Restaurant promises a memorable culinary journey by the sea.',
                restaurantImageAlt: 'Sun Flower Beach Restaurant view',
            },
            home: {
                videoSection: {
                    title: 'Welcome to Sun Flower Beach Resort',
                    description: 'Discover the breathtaking beauty of the beach, indulge in our signature Ayurvedic therapies, and enjoy a truly rejuvenating getaway by the ocean.',
                    resortLabel: 'Resort',
                    ayurvedaLabel: 'Ayurveda',
                    restaurantLabel: 'Restaurant',
                    beachLabel: 'Beach',
                },
                heroSection: {
                    subtitle: 'Sun Flower Beach Resort',
                    title: 'The Perfect Seaside Experience',
                    description: 'Sun Flower Beach Resort is a serene escape nestled along Sri Lanka’s southern coastline. This welcoming haven offers breathtaking ocean views, comfortable accommodations, delightful dining, and unforgettable seaside experiences. Perfect for both relaxation and adventure, where warm hospitality meets the beauty of the sea.',
                },
                benefitsSection: {
                    subtitle: 'Moments to Treasure',
                    title: 'Enjoy Exclusive Benefits',
                    benefit1: 'Unbeatable Rates',
                    benefit2: 'Enjoy Together: Family-Friendly Fun',
                    benefit3: 'Dining with the Ocean Breeze',
                    benefit4: 'Tailored Hospitality for Unforgettable Moments',
                    bookNow: 'Book Now',
                },
                villaSpaSection: {
                    title: 'Sun Flower Beach Resort',
                    description1: 'Discover serenity at Sun Flower Beach Resort, where seaside luxury blends seamlessly with nature’s charm. Enjoy a peaceful sanctuary by the ocean, perfect for unwinding and revitalizing your senses.',
                    description2: 'Our Ayurvedic spa offers authentic healing rituals, combining traditional therapies and natural herbal remedies to soothe your body and mind.',
                    description3: 'Whether it’s a relaxing holiday, a holistic wellness retreat, or an indulgent escape, Sun Flower Beach Resort promises exceptional care and unforgettable experiences.',
                    imageAlt1: 'Sun Flower Beach Resort view',
                    imageAlt2: 'Sun Flower Beach Resort pool view',
                },
                apartmentsSection: {
                    title1: 'Deluxe Double Rooms',
                    description1: 'Experience our elegantly appointed Deluxe Double Rooms featuring top-tier amenities and stunning scenic views.',
                    title2: 'Deluxe Double Room with Sea View',
                    description2: 'Stay in a Deluxe Double Room with Sea View, offering the perfect blend of comfort, exclusivity, and modern elegance.',
                    viewMore: 'View More',
                    imageAlt1: 'Deluxe Double Room view',
                    imageAlt2: 'Deluxe Double Room with Sea View',
                },
                ayurvedaSection: {
                    title: 'Ayurveda Wellness',
                    description1: 'At Sun Flower Beach Resort Ayurveda Wellness, we celebrate the art of rejuvenation. Our therapies combine ancient Ayurvedic traditions with modern wellness practices, delivering a holistic healing experience that brings harmony to your body and mind.',
                    description2: 'Immerse yourself in our signature spa treatments, herbal therapies, and meditation sessions designed to help you reconnect with your inner peace. Whether you seek stress relief or detoxification, we offer an unparalleled wellness retreat.',
                    viewTreatments: 'View Our Treatments',
                    imageAlt: 'Sun Flower Beach Resort Ayurveda Spa view',
                },
                villaSection: {
                    title: 'Sun Flower Beach Resort',
                    description1: 'Sun Flower Beach Resort offers a perfect blend of relaxation, comfort, and tropical charm. Nestled by the ocean, it provides an idyllic escape for families, couples, or groups seeking a peaceful seaside getaway.',
                    description2: 'With beautifully designed spaces, stunning ocean views, and warm hospitality, the resort delivers an exceptional experience. Whether you’re lounging by the beach, savoring fresh local cuisine, or enjoying rejuvenating wellness treatments, Sun Flower Beach Resort promises a truly memorable stay.',
                    viewRooms: 'View Our Rooms',
                    imageAlt: 'Sun Flower Beach Resort view',
                },
                reviewsSection: {
                    title: 'Guest Reviews',
                },
                gallerySection: {
                    title: 'Our Gallery',
                    noImages: 'No images available for this section',
                    error: 'Failed to fetch gallery items',
                    sectionLabels: {
                        All: 'All',
                        Resort: 'Resort',
                        Ayurveda: 'Ayurveda',
                        Restaurant: 'Restaurant',
                        Beach: 'Beach',
                    },
                },
                contactSection: {
                    title: 'Get in touch with us',
                    description: 'We’re here for you! Whether you’re curious about our offerings, ready to reserve your stay, or just wish to connect, feel free to get in touch with us anytime.',
                    contactUs: 'Contact Us',
                },
            },
            aboutUs: {
                introSection: {
                    title: 'Welcome to Sun Flower Beach Resort!',
                    description: 'Sun Flower Beach Resort invites you to escape into a world of coastal serenity and natural healing. Tucked away on the sun-kissed shores of Sri Lanka, the resort blends modern comfort with age-old wellness traditions. Discover the calming power of authentic Ayurveda treatments at our tranquil spa, relax in tastefully designed rooms that echo the island’s charm, and savor nutritious cuisine crafted from fresh, local ingredients. Whether you’re starting your day with yoga by the ocean or winding down with a herbal massage, every moment is designed to restore balance and peace. Sun Flower Beach Resort is more than just a stay — it’s a journey into well-being, culture, and coastal beauty.',
                    learnMore: 'Learn More',
                    seeVideo: 'See Video',
                    carouselImageAlt1: 'Sun Flower Beach Resort view 1',
                    carouselImageAlt2: 'Sun Flower Beach Resort view 2',
                    carouselImageAlt3: 'Sun Flower Beach Resort view 3',
                    carouselImageAlt4: 'Ayurvedic Spa view',
                    carouselImageAlt5: 'Sun Flower Beach Resort view 5',
                },
                eventsSection: {
                    title: 'Latest Events',
                    error: 'Failed to fetch events',
                    noEvents: 'No events available at the moment.',
                    noDate: 'N/A',
                    noDescription: 'No description available',
                    noImages: 'No images available',
                    table: {
                        eventName: 'Event Name',
                        date: 'Date',
                        description: 'Description',
                        images: 'Images',
                    },
                    eventImageAlt: 'Event {eventName} view {index}',
                },
            },
            contactUs: {
                introSection: {
                    subtitle: 'Sun Flower Beach Resort',
                    title: 'Contact Us',
                    description1: 'Thank you for reaching out to us! Your inquiries are important to us, and we appreciate your interest in our products/services.',
                    description2: 'Our dedicated team is available to assist you on weekdays from 8:30 AM to 5:00 PM (GMT+5:30) and on Saturday from 8:30 AM to 12:30 PM (GMT+5:30). Please be assured that we are committed to responding to your inquiries promptly during these hours.',
                },
                formSection: {
                    subtitle: 'Contact form',
                    title: 'FEEL FREE TO CONTACT US',
                },
                form: {
                    namePlaceholder: 'Your Name',
                    phonePlaceholder: 'Your Phone',
                    emailPlaceholder: 'Your Email',
                    subjectPlaceholder: 'Subject',
                    messagePlaceholder: 'Your Message',
                    termsLabel: 'I accept the Terms and Conditions',
                    submitButton: 'SEND YOUR MESSAGE NOW',
                    whatsappMessage: 'Name: {{name}}\nPhone: {{phone}}\nEmail: {{email}}\nSubject: {{subject}}\nMessage: {{message}}',
                },
                corporateSection: {
                    subtitle: 'Corporate Contact',
                    title: 'Sun Flower Beach Resort and Ayurveda Wellness',
                    address: '221, 7th Lane, Moragalla, Beruwala',
                    telLabel: 'Tel',
                    emailLabel: 'Email',
                },
                locationSection: {
                    title: 'Our Location',
                    mapTitle: 'Location Map',
                },
            },
            apartmentsSection: {
                subtitle: 'Stylish and cozy, our Deluxe Double Rooms promise a relaxing stay.',
                title1: 'Deluxe Double Rooms',
                aboutTitle: 'About Our Deluxe Rooms',
                description1: 'Our Deluxe Double Rooms offer an elegant and relaxing retreat, perfect for couples or travelers seeking comfort by the sea. Each room features a plush king-size bed, a modern bathroom with premium fittings, and full air-conditioning for a cool, restful stay. Designed with both style and convenience in mind, they provide the ideal space for an unforgettable experience.',
                feature1: '✔ King-size bed with premium bedding',
                feature2: '✔ High-speed Free Wi-Fi',
                feature3: '✔ 24/7 room service and concierge',
                feature4: '✔ Attached bathrooms',
                feature5: '✔ Fully air-conditioned',
                feature6: '✔ Tea-making area',
                bookNow: 'Book Now',
                bookNowMessage: 'Hello, I would like to book a Deluxe Double Room at Sun Flower Beach Resort. Can you provide more details?',
                imageAlt1: 'Deluxe Double Room view',
                subtitleSeaView: 'Deluxe double room with breathtaking sea view.',
                title2: 'Deluxe Double Room with Sea View',
                aboutTitleSeaView: 'About the Deluxe Double Room with Sea View',
                description2: 'Our Deluxe Double Rooms with Sea View offer a perfect blend of elegance and comfort, designed to create a relaxing and memorable stay. Each room features a plush king-size bed for restful nights, a spacious bathroom with premium fittings, and full air-conditioning for your comfort. Enjoy stunning sea views that add a serene backdrop to your stay. Ideal for couples or solo travelers seeking a stylish retreat by the ocean, this room combines modern amenities with breathtaking scenery for an unforgettable experience.',
                bookNowMessageSeaView: 'Hello, I would like to book a Deluxe Double Room with Sea View at Sun Flower Beach Resort. Can you provide more details?',
                imageAlt2: 'Deluxe Double Room with Sea View',
            },
            spaSection: {
                title: 'Sun Flower Beach Resort Ayurveda Wellness',
                description: 'At Sun Flower Beach Resort, discover authentic Ayurveda wellness by the ocean. Our tranquil spa offers herbal oil massages and revitalizing treatments designed to restore balance, renew energy, and rejuvenate mind, body, and soul.',
                treatmentsTitle: 'Our Ayurveda Treatments',
                viewMore: 'View More',
                enlargedImageAlt: 'Enlarged view of treatment',
                closeEnlargedImage: 'Close enlarged image',
                closeModal: 'Close',
                previousImage: 'Previous',
                nextImage: 'Next',
                descriptionTitle: 'Description',
                benefitsTitle: 'Health Benefits',
                noDescription: 'No description available.',
                noBenefits: 'No benefits listed.',
                defaultTreatmentName: 'Treatment',
                treatments: {
                    shirodhara: {
                        name: 'Shirodhara',
                        description: 'A gentle pouring of warm herbal oil over the forehead to calm the mind.',
                        benefits: [
                            'Reduces stress and anxiety',
                            'Promotes better sleep',
                            'Enhances mental clarity',
                        ],
                    },
                    steamBath: {
                        name: 'Steam Bath',
                        description: 'A detoxifying steam treatment to open pores and relax muscles.',
                        benefits: [
                            'Detoxifies the body',
                            'Improves circulation',
                            'Relieves muscle tension',
                        ],
                    },
                    flowerBath: {
                        name: 'Flower Bath',
                        description: 'A soothing bath infused with aromatic flowers for relaxation.',
                        benefits: [
                            'Calms the nervous system',
                            'Hydrates the skin',
                            'Uplifts mood',
                        ],
                    },
                    headMassage: {
                        name: 'Head Massage',
                        description: 'A relaxing massage targeting the scalp to relieve tension.',
                        benefits: [
                            'Reduces headaches',
                            'Improves scalp health',
                            'Promotes relaxation',
                        ],
                    },
                    faceMassage: {
                        name: 'Face Massage',
                        description: 'A rejuvenating massage to enhance facial glow and reduce stress.',
                        benefits: [
                            'Improves skin tone',
                            'Reduces facial tension',
                            'Promotes lymphatic drainage',
                        ],
                    },
                    neckMassage: {
                        name: 'Neck Massage',
                        description: 'Focused massage to relieve neck stiffness and tension.',
                        benefits: [
                            'Relieves neck pain',
                            'Improves flexibility',
                            'Reduces stress',
                        ],
                    },
                    shoulderMassage: {
                        name: 'Shoulder Massage',
                        description: 'Targeted massage to ease shoulder stiffness and discomfort.',
                        benefits: [
                            'Reduces shoulder pain',
                            'Improves posture',
                            'Relaxes muscles',
                        ],
                    },
                    bodyMassage: {
                        name: 'Body Massage',
                        description: 'A full-body massage to promote overall relaxation and wellness.',
                        benefits: [
                            'Enhances circulation',
                            'Relieves muscle soreness',
                            'Promotes relaxation',
                        ],
                    },
                    backMassage: {
                        name: 'Back Massage',
                        description: 'A therapeutic massage targeting back pain and tension.',
                        benefits: [
                            'Alleviates back pain',
                            'Improves spinal health',
                            'Reduces stress',
                        ],
                    },
                    footMassage: {
                        name: 'Foot Massage',
                        description: 'A soothing massage to relieve foot pain and promote relaxation.',
                        benefits: [
                            'Improves circulation',
                            'Reduces foot fatigue',
                            'Promotes relaxation',
                        ],
                    },
                },
            },
            packagesSection: {
                title: 'Our Packages',
                loadingMessage: 'Loading packages...',
                errorMessage: 'Failed to load packages. Please try again later.',
                viewDetails: 'View Details',
                bookNow: 'Book Now via WhatsApp',
                descriptionTitle: 'Description',
                featuresTitle: 'Features',
                imageAlt: 'Image of {packageName} package',
                modalContentLabel: 'Package Details',
                closeModal: 'Close',
                bookNowMessage: 'Hello! I would like to book the {packageName} package.\n\nPackage Details:\n{description}\n\nFeatures:\n{features}',
            },
            footerSection: {
                logoAlt: 'Sun Flower Beach Resort Logo',
                resortTitle: 'Sun Flower Beach Resort',
                links: {
                    home: 'Home',
                    aboutUs: 'About Us',
                    resort: 'Resort',
                    ayurvedaWellness: 'Ayurveda Wellness',
                    packages: 'Packages',
                    contactUs: 'Contact Us',
                },
                getInTouchTitle: 'Get in Touch',
                address: '6th Lane, Police Bungalow Rd, Beruwala, Sri Lanka',
                email: 'sunflower.beruwala@gmail.com',
                phone: '+94 77 534 0670',
                stayConnectedTitle: 'Stay Connected',
                emailPlaceholder: 'Enter your email',
                socialMedia: {
                    facebook: 'Follow us on Facebook',
                    instagram: 'Follow us on Instagram',
                    youtube: 'Follow us on YouTube',
                    twitter: 'Follow us on Twitter',
                },
                copyright: '© 2025 Sun Flower Beach Resort. All rights reserved.',
                developedBy: {
                    text: 'Website Designed and Developed by Redev Solutions',
                    phone: '+94 76 460 8225',
                },
            },
        },
    },
    de: {
        translation: {
            navbar: {
                home: 'Startseite',
                aboutUs: 'Über uns',
                resort: 'Resort',
                ayurvedaWellness: 'Ayurveda Wellness',
                packages: 'Pakete',
                contactUs: 'Kontakt',
            },
            language: {
                english: 'Englisch',
                german: 'Deutsch',
                russian: 'Russisch',
                french: 'Französisch',
                chinese: 'Chinesisch',
                japanese: 'Japanisch',
            },
            villa: {
                title: 'Sun Flower Beach Resort',
                description1: 'Entlang der goldenen Küsten Sri Lankas gelegen, bietet das Sun Flower Beach Resort einen ruhigen Rückzugsort, wo das Rauschen der Wellen auf luxuriösen Komfort trifft. Unsere geräumigen Luxuszimmer bieten moderne Annehmlichkeiten und atemberaubende Strandblicke, die zeitgenössische Eleganz mit dem Charme des Küstenlebens für einen unvergesslichen Aufenthalt verbinden.',
                description2: 'Gäste können authentische Ayurveda-Behandlungen genießen, erstklassige Küche mit frischen lokalen Aromen erleben und in einer Atmosphäre entspannen, die für puren Komfort gestaltet ist. Ob Sie einen friedlichen Rückzugsort, einen romantischen Kurzurlaub oder ein Abenteuer am Strand suchen, das Sun Flower Beach Resort ist das perfekte Ziel, um all Ihre Wünsche zu erfüllen.',
                imageAlt: 'Ausblick auf das Sun Flower Beach Resort',
                roomsTitle: 'Unsere Deluxe Doppelzimmer',
                roomsDescription: 'Erleben Sie Luxus und Komfort in unseren exquisit gestalteten Zimmern mit Meerblick im Sun Flower Beach Resort. Ob Sie alleine, als Paar oder mit der Familie reisen, wir bieten die perfekte Luxusunterkunft, um Ihren Strandurlaub unvergesslich zu machen.',
                singleRoomTitle: 'Deluxe Doppelzimmer',
                singleRoomAlt: 'Ausblick auf das Deluxe Doppelzimmer',
                familyRoomTitle: 'Deluxe Doppelzimmer mit Meerblick',
                familyRoomAlt: 'Deluxe Doppelzimmer mit Meerblick',
                viewDetails: 'Details ansehen',
                seaBathTitle: 'Meerblick direkt vom Resort',
                seaBathDescription1: 'Treten Sie aus dem Sun Flower Beach Resort heraus und lassen Sie sich von den goldenen Sandstränden und dem kristallklaren Wasser des Indischen Ozeans begrüßen, nur wenige Schritte von Ihrem Zimmer entfernt. Ob Sie Lust auf ein erfrischendes Bad, einen ruhigen Spaziergang am Ufer oder einfach nur Sonne tanken haben, unsere Lage am Strand bietet den perfekten Rückzugsort.',
                seaBathDescription2: 'Mit sanften Wellen, atemberaubenden Meerblicken und dem Klang des Meeres als Hintergrundmusik fühlt sich jeder Moment hier wie im Paradies an. Genießen Sie romantische Spaziergänge bei Sonnenuntergang, speisen Sie direkt am Strand unter den Sternen oder probieren Sie aufregende Wassersportarten für einen Hauch von Abenteuer – alles direkt vor der Tür des Sun Flower Beach Resorts.',
                seaBathAlt: 'Meerblick in der Nähe des Sun Flower Beach Resorts',
                restaurantTitle: 'Unser Restaurant',
                restaurantDescription1: 'Mit Blick auf die goldenen Küsten Sri Lankas bietet das Sun Flower Beach Restaurant ein herrliches kulinarisches Erlebnis, bei dem das sanfte Rauschen der Wellen die außergewöhnliche Küche ergänzt. Unsere einladende Lage am Strand verbindet die Schönheit des Ozeans mit warmer Gastfreundschaft und schafft den perfekten Ort, um jeden Bissen zu genießen.',
                restaurantDescription2: 'Gäste können frisch zubereitete Meeresfrüchte, authentische sri-lankische Aromen und internationale Gerichte aus den besten lokalen Zutaten genießen. Ob für ein romantisches Abendessen, ein Familientreffen oder eine entspannte Mahlzeit am Strand, das Sun Flower Beach Restaurant verspricht eine unvergessliche kulinarische Reise am Meer.',
                restaurantImageAlt: 'Ausblick auf das Sun Flower Beach Restaurant',
            },
            home: {
                videoSection: {
                    title: 'Willkommen im Sun Flower Beach Resort',
                    description: 'Entdecken Sie die atemberaubende Schönheit des Strandes, gönnen Sie sich unsere charakteristischen ayurvedischen Therapien und genießen Sie einen wirklich erholsamen Urlaub am Meer.',
                    resortLabel: 'Resort',
                    ayurvedaLabel: 'Ayurveda',
                    restaurantLabel: 'Restaurant',
                    beachLabel: 'Strand',
                },
                heroSection: {
                    subtitle: 'Sun Flower Beach Resort',
                    title: 'Das perfekte Stranderlebnis',
                    description: 'Das Sun Flower Beach Resort ist ein ruhiger Rückzugsort an der Südküste Sri Lankas. Dieses einladende Refugium bietet atemberaubende Meerblicke, komfortable Unterkünfte, köstliche Speisen und unvergessliche Stranderlebnisse. Perfekt für Entspannung und Abenteuer, wo herzliche Gastfreundschaft auf die Schönheit des Meeres trifft.',
                },
                benefitsSection: {
                    subtitle: 'Momente zum Schätzen',
                    title: 'Genießen Sie exklusive Vorteile',
                    benefit1: 'Unschlagbare Preise',
                    benefit2: 'Zusammen genießen: Familienfreundlicher Spaß',
                    benefit3: 'Essen mit Meeresbrise',
                    benefit4: 'Maßgeschneiderte Gastfreundschaft für unvergessliche Momente',
                    bookNow: 'Jetzt buchen',
                },
                villaSpaSection: {
                    title: 'Sun Flower Beach Resort',
                    description1: 'Entdecken Sie Gelassenheit im Sun Flower Beach Resort, wo luxuriöse Strandlage nahtlos mit dem Charme der Natur verschmilzt. Genießen Sie ein friedliches Heiligtum am Meer, perfekt zum Entspannen und Beleben Ihrer Sinne.',
                    description2: 'Unser ayurvedisches Spa bietet authentische Heilrituale, die traditionelle Therapien mit natürlichen Kräuterheilmitteln kombinieren, um Körper und Geist zu beruhigen.',
                    description3: 'Ob entspannender Urlaub, ganzheitlicher Wellness-Retreat oder verwöhnender Rückzug, das Sun Flower Beach Resort verspricht außergewöhnliche Betreuung und unvergessliche Erlebnisse.',
                    imageAlt1: 'Ausblick auf das Sun Flower Beach Resort',
                    imageAlt2: 'Ausblick auf den Pool des Sun Flower Beach Resorts',
                },
                apartmentsSection: {
                    title1: 'Deluxe Doppelzimmer',
                    description1: 'Erleben Sie unsere elegant ausgestatteten Deluxe Doppelzimmer mit erstklassigen Annehmlichkeiten und atemberaubenden Ausblicken.',
                    title2: 'Deluxe Doppelzimmer mit Meerblick',
                    description2: 'Übernachten Sie in einem Deluxe Doppelzimmer mit Meerblick, das die perfekte Kombination aus Komfort, Exklusivität und moderner Eleganz bietet.',
                    viewMore: 'Mehr ansehen',
                    imageAlt1: 'Ausblick auf das Deluxe Doppelzimmer',
                    imageAlt2: 'Deluxe Doppelzimmer mit Meerblick',
                },
                ayurvedaSection: {
                    title: 'Ayurveda Wellness',
                    description1: 'Im Sun Flower Beach Resort Ayurveda Wellness feiern wir die Kunst der Erneuerung. Unsere Therapien kombinieren alte ayurvedische Traditionen mit modernen Wellness-Praktiken und bieten ein ganzheitliches Heilerlebnis, das Harmonie für Körper und Geist bringt.',
                    description2: 'Tauchen Sie ein in unsere charakteristischen Spa-Behandlungen, Kräutertherapien und Meditationssitzungen, die darauf ausgelegt sind, Ihnen zu helfen, Ihre innere Ruhe wiederzufinden. Ob Stressabbau oder Entgiftung, wir bieten einen unvergleichlichen Wellness-Retreat.',
                    viewTreatments: 'Unsere Behandlungen ansehen',
                    imageAlt: 'Ausblick auf das Sun Flower Beach Resort Ayurveda Spa',
                },
                villaSection: {
                    title: 'Sun Flower Beach Resort',
                    description1: 'Das Sun Flower Beach Resort bietet eine perfekte Mischung aus Entspannung, Komfort und tropischem Charme. Am Meer gelegen, bietet es einen idyllischen Rückzugsort für Familien, Paare oder Gruppen, die einen friedlichen Strandurlaub suchen.',
                    description2: 'Mit wunderschön gestalteten Räumen, atemberaubenden Meerblicken und herzlicher Gastfreundschaft bietet das Resort ein außergewöhnliches Erlebnis. Ob Sie am Strand entspannen, frische lokale Küche genießen oder erfrischende Wellness-Behandlungen erleben, das Sun Flower Beach Resort verspricht einen wirklich unvergesslichen Aufenthalt.',
                    viewRooms: 'Unsere Zimmer ansehen',
                    imageAlt: 'Ausblick auf das Sun Flower Beach Resort',
                },
                reviewsSection: {
                    title: 'Gästebewertungen',
                },
                gallerySection: {
                    title: 'Unsere Galerie',
                    noImages: 'Keine Bilder für diesen Abschnitt verfügbar',
                    error: 'Fehler beim Abrufen der Galerieelemente',
                    sectionLabels: {
                        All: 'Alle',
                        Resort: 'Resort',
                        Ayurveda: 'Ayurveda',
                        Restaurant: 'Restaurant',
                        Beach: 'Strand',
                    },
                },
                contactSection: {
                    title: 'Kontaktieren Sie uns',
                    description: 'Wir sind für Sie da! Ob Sie neugierig auf unser Angebot sind, Ihren Aufenthalt reservieren möchten oder einfach nur Kontakt aufnehmen wollen, zögern Sie nicht, uns jederzeit zu erreichen.',
                    contactUs: 'Kontaktieren Sie uns',
                },
            },
            aboutUs: {
                introSection: {
                    title: 'Willkommen im Sun Flower Beach Resort!',
                    description: 'Das Sun Flower Beach Resort lädt Sie ein, in eine Welt voller Küstenruhe und natürlicher Heilung zu entfliehen. An den sonnenverwöhnten Stränden Sri Lankas gelegen, verbindet das Resort modernen Komfort mit jahrtausendealten Wellness-Traditionen. Entdecken Sie die beruhigende Kraft authentischer Ayurveda-Behandlungen in unserem ruhigen Spa, entspannen Sie in geschmackvoll gestalteten Zimmern, die den Charme der Insel widerspiegeln, und genießen Sie nahrhafte Küche aus frischen, lokalen Zutaten. Ob Sie Ihren Tag mit Yoga am Meer beginnen oder mit einer Kräutermassage ausklingen lassen, jeder Moment ist darauf ausgelegt, Gleichgewicht und Frieden wiederherzustellen. Das Sun Flower Beach Resort ist mehr als nur ein Aufenthalt — es ist eine Reise in Wohlbefinden, Kultur und Küstenschönheit.',
                    learnMore: 'Mehr erfahren',
                    seeVideo: 'Video ansehen',
                    carouselImageAlt1: 'Ausblick auf das Sun Flower Beach Resort 1',
                    carouselImageAlt2: 'Ausblick auf das Sun Flower Beach Resort 2',
                    carouselImageAlt3: 'Ausblick auf das Sun Flower Beach Resort 3',
                    carouselImageAlt4: 'Ausblick auf das Ayurveda Spa',
                    carouselImageAlt5: 'Ausblick auf das Sun Flower Beach Resort 5',
                },
                eventsSection: {
                    title: 'Neueste Veranstaltungen',
                    error: 'Fehler beim Abrufen der Veranstaltungen',
                    noEvents: 'Derzeit sind keine Veranstaltungen verfügbar.',
                    noDate: 'N/A',
                    noDescription: 'Keine Beschreibung verfügbar',
                    noImages: 'Keine Bilder verfügbar',
                    table: {
                        eventName: 'Veranstaltungsname',
                        date: 'Datum',
                        description: 'Beschreibung',
                        images: 'Bilder',
                    },
                    eventImageAlt: 'Veranstaltung {eventName} Ansicht {index}',
                },
            },
            contactUs: {
                introSection: {
                    subtitle: 'Sun Flower Beach Resort',
                    title: 'Kontaktieren Sie uns',
                    description1: 'Vielen Dank, dass Sie uns kontaktieren! Ihre Anfragen sind uns wichtig, und wir schätzen Ihr Interesse an unseren Produkten/Dienstleistungen.',
                    description2: 'Unser engagiertes Team steht Ihnen wochentags von 8:30 bis 17:00 Uhr (GMT+5:30) und samstags von 8:30 bis 12:30 Uhr (GMT+5:30) zur Verfügung. Seien Sie versichert, dass wir uns bemühen, Ihre Anfragen während dieser Zeiten schnell zu beantworten.',
                },
                formSection: {
                    subtitle: 'Kontaktformular',
                    title: 'KONTAKTIEREN SIE UNS GERNE',
                },
                form: {
                    namePlaceholder: 'Ihr Name',
                    phonePlaceholder: 'Ihre Telefonnummer',
                    emailPlaceholder: 'Ihre E-Mail',
                    subjectPlaceholder: 'Betreff',
                    messagePlaceholder: 'Ihre Nachricht',
                    termsLabel: 'Ich akzeptiere die Allgemeinen Geschäftsbedingungen',
                    submitButton: 'JETZT IHRE NACHRICHT SENDEN',
                    whatsappMessage: 'Name: {{name}}\nTelefon: {{phone}}\nE-Mail: {{email}}\nBetreff: {{subject}}\nNachricht: {{message}}',
                },
                corporateSection: {
                    subtitle: 'Unternehmenskontakt',
                    title: 'Sun Flower Beach Resort und Ayurveda Wellness',
                    address: '221, 7th Lane, Moragalla, Beruwala',
                    telLabel: 'Tel',
                    emailLabel: 'E-Mail',
                },
                locationSection: {
                    title: 'Unser Standort',
                    mapTitle: 'Standortkarte',
                },
            },
            apartmentsSection: {
                subtitle: 'Stilvoll und gemütlich, unsere Deluxe Doppelzimmer versprechen einen erholsamen Aufenthalt.',
                title1: 'Deluxe Doppelzimmer',
                aboutTitle: 'Über unsere Deluxe Zimmer',
                description1: 'Unsere Deluxe Doppelzimmer bieten einen eleganten und entspannenden Rückzugsort, perfekt für Paare oder Reisende, die Komfort am Meer suchen. Jedes Zimmer verfügt über ein plüschiges Kingsize-Bett, ein modernes Badezimmer mit hochwertigen Armaturen und eine Klimaanlage für einen kühlen, erholsamen Aufenthalt. Mit Stil und Komfort im Sinn gestaltet, bieten sie den idealen Raum für ein unvergessliches Erlebnis.',
                feature1: '✔ Kingsize-Bett mit hochwertiger Bettwäsche',
                feature2: '✔ Kostenloses High-Speed-WLAN',
                feature3: '✔ Rund-um-die-Uhr Zimmerservice und Concierge',
                feature4: '✔ Angeschlossene Badezimmer',
                feature5: '✔ Vollständig klimatisiert',
                feature6: '✔ Teezubereitungsbereich',
                bookNow: 'Jetzt buchen',
                bookNowMessage: 'Hallo, ich möchte ein Deluxe Doppelzimmer im Sun Flower Beach Resort buchen. Können Sie weitere Details geben?',
                imageAlt1: 'Ausblick auf das Deluxe Doppelzimmer',
                subtitleSeaView: 'Deluxe Doppelzimmer mit atemberaubendem Meerblick.',
                title2: 'Deluxe Doppelzimmer mit Meerblick',
                aboutTitleSeaView: 'Über das Deluxe Doppelzimmer mit Meerblick',
                description2: 'Unsere Deluxe Doppelzimmer mit Meerblick bieten eine perfekte Mischung aus Eleganz und Komfort, gestaltet für einen entspannenden und unvergesslichen Aufenthalt. Jedes Zimmer verfügt über ein plüschiges Kingsize-Bett für erholsame Nächte, ein geräumiges Badezimmer mit hochwertigen Armaturen und eine Klimaanlage für Ihren Komfort. Genießen Sie atemberaubende Meerblicke, die Ihrem Aufenthalt eine ruhige Kulisse verleihen. Ideal für Paare oder Alleinreisende, die einen stilvollen Rückzugsort am Ozean suchen, kombiniert dieses Zimmer moderne Annehmlichkeiten mit beeindruckender Landschaft für ein unvergessliches Erlebnis.',
                bookNowMessageSeaView: 'Hallo, ich möchte ein Deluxe Doppelzimmer mit Meerblick im Sun Flower Beach Resort buchen. Können Sie weitere Details geben?',
                imageAlt2: 'Deluxe Doppelzimmer mit Meerblick',
            },
            spaSection: {
                title: 'Sun Flower Beach Resort Ayurveda Wellness',
                description: 'Im Sun Flower Beach Resort tauchen Sie ein in die Kunst der Heilung mit unseren authentischen Ayurveda-Wellness-Erlebn10.',
                treatmentsTitle: 'Unsere Ayurveda-Behandlungen',
                viewMore: 'Mehr anzeigen',
                enlargedImageAlt: 'Vergrößerte Ansicht der Behandlung',
                closeEnlargedImage: 'Vergrößertes Bild schließen',
                closeModal: 'Schließen',
                previousImage: 'Vorheriges Bild',
                nextImage: 'Nächstes Bild',
                descriptionTitle: 'Beschreibung',
                benefitsTitle: 'Gesundheitliche Vorteile',
                noDescription: 'Keine Beschreibung verfügbar.',
                noBenefits: 'Keine Vorteile aufgelistet.',
                defaultTreatmentName: 'Behandlung',
                treatments: {
                    shirodhara: {
                        name: 'Shirodhara',
                        description: 'Ein sanftes Gießen von warmem Kräuteröl über die Stirn, um den Geist zu beruhigen.',
                        benefits: [
                            'Reduziert Stress und Angst',
                            'Fördert besseren Schlaf',
                            'Verbessert die geistige Klarheit',
                        ],
                    },
                    steamBath: {
                        name: 'Dampfbad',
                        description: 'Eine entgiftende Dampfbehandlung, um Poren zu öffnen und Muskeln zu entspannen.',
                        benefits: [
                            'Entgiftet den Körper',
                            'Verbessert die Durchblutung',
                            'Lindert Muskelverspannungen',
                        ],
                    },
                    flowerBath: {
                        name: 'Blumenbad',
                        description: 'Ein beruhigendes Bad mit aromatischen Blumen zur Entspannung.',
                        benefits: [
                            'Beruhigt das Nervensystem',
                            'Hydratisiert die Haut',
                            'Hebt die Stimmung',
                        ],
                    },
                    headMassage: {
                        name: 'Kopfmassage',
                        description: 'Eine entspannende Massage, die auf die Kopfhaut abzielt, um Spannungen zu lösen.',
                        benefits: [
                            'Reduziert Kopfschmerzen',
                            'Verbessert die Kopfhautgesundheit',
                            'Fördert die Entspannung',
                        ],
                    },
                    faceMassage: {
                        name: 'Gesichtsmassage',
                        description: 'Eine verjüngende Massage, um den Gesichtsglanz zu verbessern und Stress abzubauen.',
                        benefits: [
                            'Verbessert den Hautton',
                            'Reduziert Gesichtsspannungen',
                            'Fördert die lymphatische Drainage',
                        ],
                    },
                    neckMassage: {
                        name: 'Nackenmassage',
                        description: 'Ge zielte Massage zur Linderung von Nackensteifheit und -spannung.',
                        benefits: [
                            'Lindert Nackenschmerzen',
                            'Verbessert die Flexibilität',
                            'Reduziert Stress',
                        ],
                    },
                    shoulderMassage: {
                        name: 'Schultermassage',
                        description: 'Ge zielte Massage zur Linderung von Schultersteifheit und -beschwerden.',
                        benefits: [
                            'Reduziert Schulterschmerzen',
                            'Verbessert die Haltung',
                            'Entspannt die Muskeln',
                        ],
                    },
                    bodyMassage: {
                        name: 'Ganzkörpermassage',
                        description: 'Eine Ganzkörpermassage zur Förderung von allgemeiner Entspannung und Wohlbefinden.',
                        benefits: [
                            'Verbessert die Durchblutung',
                            'Lindert Muskelschmerzen',
                            'Fördert die Entspannung',
                        ],
                    },
                    backMassage: {
                        name: 'Rückenmassage',
                        description: 'Eine therapeutische Massage zur Linderung von Rückenschmerzen und -spannungen.',
                        benefits: [
                            'Lindert Rückenschmerzen',
                            'Verbessert die Gesundheit der Wirbelsäule',
                            'Reduziert Stress',
                        ],
                    },
                    footMassage: {
                        name: 'Fußmassage',
                        description: 'Eine beruhigende Massage zur Linderung von Fußschmerzen und Förderung der Entspannung.',
                        benefits: [
                            'Verbessert die Durchblutung',
                            'Reduziert Fußermüdung',
                            'Fördert die Entspannung',
                        ],
                    },
                },
            },
            packagesSection: {
                title: 'Unsere Pakete',
                loadingMessage: 'Pakete werden geladen...',
                errorMessage: 'Fehler beim Laden der Pakete. Bitte versuchen Sie es später erneut.',
                viewDetails: 'Details anzeigen',
                bookNow: 'Jetzt über WhatsApp buchen',
                descriptionTitle: 'Beschreibung',
                featuresTitle: 'Merkmale',
                imageAlt: 'Bild des {packageName} Pakets',
                modalContentLabel: 'Paketdetails',
                closeModal: 'Schließen',
                bookNowMessage: 'Hallo! Ich möchte das {packageName} Paket buchen.\n\nPaketdetails:\n{description}\n\nMerkmale:\n{features}',
            },
            footerSection: {
                logoAlt: 'Sun Flower Beach Resort Logo',
                resortTitle: 'Sun Flower Beach Resort',
                links: {
                    home: 'Startseite',
                    aboutUs: 'Über uns',
                    resort: 'Resort',
                    ayurvedaWellness: 'Ayurveda Wellness',
                    packages: 'Pakete',
                    contactUs: 'Kontakt',
                },
                getInTouchTitle: 'In Kontakt bleiben',
                address: '6th Lane, Police Bungalow Rd, Beruwala, Sri Lanka',
                email: 'sunflower.beruwala@gmail.com',
                phone: '+94 77 534 0670',
                stayConnectedTitle: 'Verbunden bleiben',
                emailPlaceholder: 'Geben Sie Ihre E-Mail ein',
                socialMedia: {
                    facebook: 'Folgen Sie uns auf Facebook',
                    instagram: 'Folgen Sie uns auf Instagram',
                    youtube: 'Folgen Sie uns auf YouTube',
                    twitter: 'Folgen Sie uns auf Twitter',
                },
                copyright: '© 2025 Sun Flower Beach Resort. Alle Rechte vorbehalten.',
                developedBy: {
                    text: 'Website entworfen und entwickelt von Redev Solutions',
                    phone: '+94 76 460 8225',
                },
            },
        },
    },
    ru: {
        translation: {
            navbar: {
                home: 'Главная',
                aboutUs: 'О нас',
                resort: 'Курорт',
                ayurvedaWellness: 'Аюрведа',
                packages: 'Пакеты',
                contactUs: 'Контакты',
            },
            language: {
                english: 'Английский',
                german: 'Немецкий',
                russian: 'Русский',
                french: 'Французский',
                chinese: 'Китайский',
                japanese: 'Японский',
            },
            villa: {
                title: 'Курорт Sun Flower Beach',
                description1: 'Расположенный вдоль золотых берегов Шри-Ланки, курорт Sun Flower Beach предлагает спокойное уединение, где шум волн сочетается с роскошным комфортом. Наши просторные люксовые номера оснащены современными удобствами и потрясающими видами на пляж, сочетая современную элегантность с очарованием прибрежной жизни для незабываемого отдыха.',
                description2: 'Гости могут насладиться аутентичными аюрведическими процедурами, отведать блюда мирового уровня с местными вкусами и расслабиться в атмосфере, созданной для чистого комфорта. Ищете ли вы спокойный отдых, романтическое путешествие или приключение на пляже, курорт Sun Flower Beach — идеальное место для исполнения всех ваших желаний.',
                imageAlt: 'Вид на курорт Sun Flower Beach',
                roomsTitle: 'Наши люксовые двухместные номера',
                roomsDescription: 'Ощутите роскошь и комфорт в наших изысканно оформленных номерах с видом на пляж в курорте Sun Flower Beach. Путешествуете ли вы в одиночку, парой или с семьей, мы предлагаем идеальное роскошное размещение, чтобы сделать ваш отдых на море поистине незабываемым.',
                singleRoomTitle: 'Люксовые двухместные номера',
                singleRoomAlt: 'Вид на люксовый двухместный номер',
                familyRoomTitle: 'Люксовый двухместный номер с видом на море',
                familyRoomAlt: 'Люксовый двухместный номер с видом на море',
                viewDetails: 'Посмотреть подробности',
                seaBathTitle: 'Вид на море прямо из курорта',
                seaBathDescription1: 'Выйдите из курорта Sun Flower Beach, и вас встретят золотые пески и кристально чистые воды Индийского океана всего в нескольких шагах от вашего номера. Хотите ли вы освежиться в море, спокойно прогуляться по берегу или просто насладиться солнцем, наше расположение на пляже предлагает идеальное уединение.',
                seaBathDescription2: 'С мягкими волнами, захватывающими видами на океан и звуком моря в качестве саундтрека каждый момент здесь ощущается как рай. Наслаждайтесь романтическими прогулками на закате, ужинами на пляже под звездами или попробуйте захватывающие водные виды спорта для прилива адреналина — все это прямо у порога курорта Sun Flower Beach.',
                seaBathAlt: 'Вид на море рядом с курортом Sun Flower Beach',
                restaurantTitle: 'Наш ресторан',
                restaurantDescription1: 'С видом на золотые берега Шри-Ланки ресторан Sun Flower Beach предлагает восхитительный кулинарный опыт, где мягкий шум волн дополняет исключительную кухню. Наше привлекательное расположение на пляже сочетает красоту океана с теплым гостеприимством, создавая идеальное место для наслаждения каждым кусочком.',
                restaurantDescription2: 'Гости могут насладиться свежеприготовленными морепродуктами, аутентичными вкусами Шри-Ланки и международными блюдами, приготовленными из лучших местных ингредиентов. Будь то романтический ужин, семейное собрание или расслабленная трапеза на пляже, ресторан Sun Flower Beach обещает незабываемое кулинарное путешествие у моря.',
                restaurantImageAlt: 'Вид на ресторан Sun Flower Beach',
            },
            home: {
                videoSection: {
                    title: 'Добро пожаловать в курорт Sun Flower Beach',
                    description: 'Откройте для себя захватывающую красоту пляжа, побалуйте себя нашими фирменными аюрведическими процедурами и насладитесь поистине восстанавливающим отдыхом у океана.',
                    resortLabel: 'Курорт',
                    ayurvedaLabel: 'Аюрведа',
                    restaurantLabel: 'Ресторан',
                    beachLabel: 'Пляж',
                },
                heroSection: {
                    subtitle: 'Курорт Sun Flower Beach',
                    title: 'Идеальный отдых на море',
                    description: 'Курорт Sun Flower Beach — это спокойное уединение на южном побережье Шри-Ланки. Этот гостеприимный оазис предлагает потрясающие виды на океан, комфортное размещение, восхитительную кухню и незабываемые впечатления от отдыха на море. Идеально подходит как для релакса, так и для приключений, где теплое гостеприимство сочетается с красотой моря.',
                },
                benefitsSection: {
                    subtitle: 'Моменты, которые стоит ценить',
                    title: 'Наслаждайтесь эксклюзивными преимуществами',
                    benefit1: 'Непревзойденные цены',
                    benefit2: 'Вместе веселее: семейные развлечения',
                    benefit3: 'Ужин с морским бризом',
                    benefit4: 'Индивидуальное гостеприимство для незабываемых моментов',
                    bookNow: 'Забронировать сейчас',
                },
                villaSpaSection: {
                    title: 'Курорт Sun Flower Beach',
                    description1: 'Откройте для себя спокойствие в курорте Sun Flower Beach, где роскошь у моря гармонично сочетается с природным очарованием. Наслаждайтесь мирным убежищем у океана, идеальным для расслабления и восстановления ваших чувств.',
                    description2: 'Наш аюрведический спа предлагает аутентичные целебные ритуалы, сочетая традиционные терапии с натуральными травяными средствами для успокоения тела и разума.',
                    description3: 'Будь то расслабляющий отпуск, целостный оздоровительный ретрит или роскошный отдых, курорт Sun Flower Beach обещает исключительный уход и незабываемые впечатления.',
                    imageAlt1: 'Вид на курорт Sun Flower Beach',
                    imageAlt2: 'Вид на бассейн курорта Sun Flower Beach',
                },
                apartmentsSection: {
                    title1: 'Люксовые двухместные номера',
                    description1: 'Ощутите наши элегантно оформленные люксовые двухместные номера с первоклассными удобствами и потрясающими видами.',
                    title2: 'Люксовый двухместный номер с видом на море',
                    description2: 'Остановитесь в люксовом двухместном номере с видом на море, предлагающем идеальное сочетание комфорта, эксклюзивности и современной элегантности.',
                    viewMore: 'Посмотреть больше',
                    imageAlt1: 'Вид на люксовый двухместный номер',
                    imageAlt2: 'Люксовый двухместный номер с видом на море',
                },
                ayurvedaSection: {
                    title: 'Аюрведа Wellness',
                    description1: 'В Sun Flower Beach Resort Ayurveda Wellness мы прославляем искусство восстановления. Наши терапии сочетают древние аюрведические традиции с современными оздоровительными практиками, предлагая целостный целебный опыт, который приносит гармонию телу и разуму.',
                    description2: 'Погрузитесь в наши фирменные спа-процедуры, травяные терапии и медитационные сессии, созданные для того, чтобы помочь вам восстановить внутренний покой. Ищете ли вы снятие стресса или детоксикацию, мы предлагаем непревзойденный оздоровительный ретрит.',
                    viewTreatments: 'Посмотреть наши процедуры',
                    imageAlt: 'Вид на аюрведический спа курорта Sun Flower Beach',
                },
                villaSection: {
                    title: 'Курорт Sun Flower Beach',
                    description1: 'Курорт Sun Flower Beach предлагает идеальное сочетание релакса, комфорта и тропического очарования. Расположенный у океана, он предоставляет идиллическое уединение для семей, пар или групп, ищущих спокойный отдых на море.',
                    description2: 'С красиво оформленными пространствами, потрясающими видами на океан и теплым гостеприимством курорт предлагает исключительный опыт. Отдыхаете ли вы на пляже, наслаждаетесь свежей местной кухней или восстанавливающими оздоровительными процедурами, курорт Sun Flower Beach обещает поистине незабываемый отдых.',
                    viewRooms: 'Посмотреть наши номера',
                    imageAlt: 'Вид на курорт Sun Flower Beach',
                },
                reviewsSection: {
                    title: 'Отзывы гостей',
                },
                gallerySection: {
                    title: 'Наша галерея',
                    noImages: 'Нет доступных изображений для этого раздела',
                    error: 'Не удалось загрузить элементы галереи',
                    sectionLabels: {
                        All: 'Все',
                        Resort: 'Курорт',
                        Ayurveda: 'Аюрведа',
                        Restaurant: 'Ресторан',
                        Beach: 'Пляж',
                    },
                },
                contactSection: {
                    title: 'Свяжитесь с нами',
                    description: 'Мы здесь для вас! Будь то вопросы о наших услугах, бронирование проживания или просто желание связаться, не стесняйтесь обращаться к нам в любое время.',
                    contactUs: 'Свяжитесь с нами',
                },
            },
            aboutUs: {
                introSection: {
                    title: 'Добро пожаловать в курорт Sun Flower Beach!',
                    description: 'Курорт Sun Flower Beach приглашает вас сбежать в мир прибрежного спокойствия и естественного исцеления. Расположенный на солнечных берегах Шри-Ланки, курорт сочетает современный комфорт с древними традициями оздоровления. Откройте для себя успокаивающую силу аутентичных аюрведических процедур в нашем спокойном спа, расслабьтесь в со вкусом оформленных номерах, отражающих очарование острова, и наслаждайтесь питательной кухней, приготовленной из свежих местных ингредиентов. Будь то утренние занятия йогой у океана или расслабляющий массаж с травами, каждый момент создан для восстановления баланса и покоя. Курорт Sun Flower Beach — это не просто пребывание, это путешествие в благополучие, культуру и прибрежную красоту.',
                    learnMore: 'Узнать больше',
                    seeVideo: 'Посмотреть видео',
                    carouselImageAlt1: 'Вид на курорт Sun Flower Beach 1',
                    carouselImageAlt2: 'Вид на курорт Sun Flower Beach 2',
                    carouselImageAlt3: 'Вид на курорт Sun Flower Beach 3',
                    carouselImageAlt4: 'Вид на аюрведический спа',
                    carouselImageAlt5: 'Вид на курорт Sun Flower Beach 5',
                },
                eventsSection: {
                    title: 'Последние события',
                    error: 'Не удалось загрузить события',
                    noEvents: 'На данный момент события отсутствуют.',
                    noDate: 'Н/Д',
                    noDescription: 'Описание отсутствует',
                    noImages: 'Изображения отсутствуют',
                    table: {
                        eventName: 'Название события',
                        date: 'Дата',
                        description: 'Описание',
                        images: 'Изображения',
                    },
                    eventImageAlt: 'Вид события {eventName} {index}',
                },
            },
            contactUs: {
                introSection: {
                    subtitle: 'Sun Flower Beach Resort',
                    title: 'Свяжитесь с нами',
                    description1: 'Спасибо, что обратились к нам! Ваши запросы важны для нас, и мы ценим ваш интерес к нашим продуктам/услугам.',
                    description2: 'Наша преданная команда готова помочь вам в будние дни с 8:30 до 17:00 (GMT+5:30) и в субботу с 8:30 до 12:30 (GMT+5:30). Будьте уверены, мы стремимся оперативно отвечать на ваши запросы в эти часы.',
                },
                formSection: {
                    subtitle: 'Форма обратной связи',
                    title: 'СВЯЖИТЕСЬ С НАМИ',
                },
                form: {
                    namePlaceholder: 'Ваше имя',
                    phonePlaceholder: 'Ваш телефон',
                    emailPlaceholder: 'Ваш email',
                    subjectPlaceholder: 'Тема',
                    messagePlaceholder: 'Ваше сообщение',
                    termsLabel: 'Я принимаю Условия и положения',
                    submitButton: 'ОТПРАВИТЬ СООБЩЕНИЕ СЕЙЧАС',
                    whatsappMessage: 'Имя: {{name}}\nТелефон: {{phone}}\nEmail: {{email}}\nТема: {{subject}}\nСообщение: {{message}}',
                },
                corporateSection: {
                    subtitle: 'Корпоративные контакты',
                    title: 'Sun Flower Beach Resort и Ayurveda Wellness',
                    address: '221, 7th Lane, Moragalla, Beruwala',
                    telLabel: 'Тел',
                    emailLabel: 'Email',
                },
                locationSection: {
                    title: 'Наше местоположение',
                    mapTitle: 'Карта местоположения',
                },
            },
            apartmentsSection: {
                subtitle: 'Стильные и уютные, наши люксовые двухместные номера обещают расслабляющий отдых.',
                title1: 'Люксовые двухместные номера',
                aboutTitle: 'О наших люксовых номерах',
                description1: 'Наши люксовые двухместные номера предлагают элегантное и расслабляющее уединение, идеальное для пар или путешественников, ищущих комфорт у моря. Каждый номер оснащен плюшевой кроватью king-size, современной ванной комнатой с премиальными удобствами и полной кондиционировкой для прохладного, спокойного отдыха. Разработанные с учетом стиля и удобства, они предоставляют идеальное пространство для незабываемого опыта.',
                feature1: '✔ Кровать king-size с премиальным постельным бельем',
                feature2: '✔ Высокоскоростной бесплатный Wi-Fi',
                feature3: '✔ Круглосуточное обслуживание номеров и консьерж',
                feature4: '✔ Примыкающие ванные комнаты',
                feature5: '✔ Полностью кондиционированные',
                feature6: '✔ Зона для приготовления чая',
                bookNow: 'Забронировать сейчас',
                bookNowMessage: 'Здравствуйте, я хотел бы забронировать люксовый двухместный номер в курорте Sun Flower Beach. Можете ли вы предоставить больше информации?',
                imageAlt1: 'Вид на люксовый двухместный номер',
                subtitleSeaView: 'Люксовый двухместный номер с захватывающим видом на море.',
                title2: 'Люксовый двухместный номер с видом на море',
                aboutTitleSeaView: 'О люксовом двухместном номере с видом на море',
                description2: 'Наши люксовые двухместные номера с видом на море предлагают идеальное сочетание элегантности и комфорта, созданное для расслабляющего и запоминающегося отдыха. Каждый номер оснащен плюшевой кроватью king-size для спокойных ночей, просторной ванной комнатой с премиальными удобствами и полной кондиционировкой для вашего комфорта. Наслаждайтесь потрясающими видами на море, которые создают спокойный фон для вашего пребывания. Идеально подходит для пар или одиночных путешественников, ищущих стильное уединение у океана, этот номер сочетает современные удобства с захватывающей природой для незабываемого опыта.',
                bookNowMessageSeaView: 'Здравствуйте, я хотел бы забронировать люксовый двухместный номер с видом на море в курорте Sun Flower Beach. Можете ли вы предоставить больше информации?',
                imageAlt2: 'Люксовый двухместный номер с видом на море',
            },
            spaSection: {
                title: 'Аюрведическое велнес-пространство Sun Flower Beach Resort',
                description: 'В Sun Flower Beach Resort погрузитесь в искусство исцеления с нашими аутентичными аюрведическими велнес-программами. Расположенный у океана, наш спокойный спа-центр предлагает традиционные терапии, предназначенные для омоложения вашего разума, тела и души. От успокаивающих массажей с травяными маслами до восстанавливающих процедур, подобранных под ваши потребности, каждая сессия создана для восстановления баланса, повышения жизненной силы и полного обновления.',
                treatmentsTitle: 'Наши аюрведические процедуры',
                viewMore: 'Посмотреть больше',
                enlargedImageAlt: 'Увеличенное изображение процедуры',
                closeEnlargedImage: 'Закрыть увеличенное изображение',
                closeModal: 'Закрыть',
                previousImage: 'Предыдущее',
                nextImage: 'Следующее',
                descriptionTitle: 'Описание',
                benefitsTitle: 'Польза для здоровья',
                noDescription: 'Описание отсутствует.',
                noBenefits: 'Преимущества не указаны.',
                defaultTreatmentName: 'Процедура',
                treatments: {
                    shirodhara: {
                        name: 'Широдхара',
                        description: 'Мягкое литье теплого травяного масла на лоб для успокоения ума.',
                        benefits: [
                            'Снижает стресс и тревогу',
                            'Способствует лучшему сну',
                            'Улучшает ясность ума',
                        ],
                    },
                    steamBath: {
                        name: 'Паровая баня',
                        description: 'Детоксикационная паровая процедура для открытия пор и расслабления мышц.',
                        benefits: [
                            'Детоксикация организма',
                            'Улучшает кровообращение',
                            'Снимает мышечное напряжение',
                        ],
                    },
                    flowerBath: {
                        name: 'Цветочная ванна',
                        description: 'Успокаивающая ванна с ароматическими цветами для релаксации.',
                        benefits: [
                            'Успокаивает нервную систему',
                            'Увлажняет кожу',
                            'Поднимает настроение',
                        ],
                    },
                    headMassage: {
                        name: 'Массаж головы',
                        description: 'Расслабляющий массаж, направленный на кожу головы для снятия напряжения.',
                        benefits: [
                            'Уменьшает головные боли',
                            'Улучшает здоровье кожи головы',
                            'Способствует релаксации',
                        ],
                    },
                    faceMassage: {
                        name: 'Массаж лица',
                        description: 'Омолаживающий массаж для улучшения сияния лица и снятия стресса.',
                        benefits: [
                            'Улучшает тон кожи',
                            'Снижает напряжение лица',
                            'Способствует лимфодренажу',
                        ],
                    },
                    neckMassage: {
                        name: 'Массаж шеи',
                        description: 'Целенаправленный массаж для снятия жесткости и напряжения шеи.',
                        benefits: [
                            'Снимает боль в шее',
                            'Улучшает гибкость',
                            'Снижает стресс',
                        ],
                    },
                    shoulderMassage: {
                        name: 'Массаж плеч',
                        description: 'Целенаправленный массаж для снятия жесткости и дискомфорта в плечах.',
                        benefits: [
                            'Уменьшает боль в плечах',
                            'Улучшает осанку',
                            'Расслабляет мышцы',
                        ],
                    },
                    bodyMassage: {
                        name: 'Массаж тела',
                        description: 'Массаж всего тела для общего расслабления и благополучия.',
                        benefits: [
                            'Улучшает кровообращение',
                            'Снимает мышечную боль',
                            'Способствует релаксации',
                        ],
                    },
                    backMassage: {
                        name: 'Массаж спины',
                        description: 'Терапевтический массаж для снятия боли и напряжения в спине.',
                        benefits: [
                            'Облегчает боль в спине',
                            'Улучшает здоровье позвоночника',
                            'Снижает стресс',
                        ],
                    },
                    footMassage: {
                        name: 'Массаж стоп',
                        description: 'Успокаивающий массаж для снятия боли в стопах и релаксации.',
                        benefits: [
                            'Улучшает кровообращение',
                            'Снижает усталость стоп',
                            'Способствует релаксации',
                        ],
                    },
                },
            },
            packagesSection: {
                title: 'Наши пакеты',
                loadingMessage: 'Загрузка пакетов...',
                errorMessage: 'Не удалось загрузить пакеты. Пожалуйста, попробуйте снова позже.',
                viewDetails: 'Посмотреть детали',
                bookNow: 'Забронировать через WhatsApp',
                descriptionTitle: 'Описание',
                featuresTitle: 'Особенности',
                imageAlt: 'Изображение пакета {packageName}',
                modalContentLabel: 'Детали пакета',
                closeModal: 'Закрыть',
                bookNowMessage: 'Здравствуйте! Я хотел бы забронировать пакет {packageName}.\n\nДетали пакета:\n{description}\n\nОсобенности:\n{features}',
            },
            footerSection: {
                logoAlt: 'Логотип Sun Flower Beach Resort',
                resortTitle: 'Sun Flower Beach Resort',
                links: {
                    home: 'Главная',
                    aboutUs: 'О нас',
                    resort: 'Курорт',
                    ayurvedaWellness: 'Аюрведическое велнес',
                    packages: 'Пакеты',
                    contactUs: 'Связаться с нами',
                },
                getInTouchTitle: 'Связаться с нами',
                address: '6-я линия, Police Bungalow Rd, Беруала, Шри-Ланка',
                email: 'sunflower.beruwala@gmail.com',
                phone: '+94 77 534 0670',
                stayConnectedTitle: 'Оставайтесь на связи',
                emailPlaceholder: 'Введите ваш email',
                socialMedia: {
                    facebook: 'Подписывайтесь на нас в Facebook',
                    instagram: 'Подписывайтесь на нас в Instagram',
                    youtube: 'Подписывайтесь на нас в YouTube',
                    twitter: 'Подписывайтесь на нас в Twitter',
                },
                copyright: '© 2025 Sun Flower Beach Resort. Все права защищены.',
                developedBy: {
                    text: 'Веб-сайт разработан компанией Redev Solutions',
                    phone: '+94 76 460 8225',
                },
            },
        },
    },
    fr: {
        translation: {
            navbar: {
                home: 'Accueil',
                aboutUs: 'À propos',
                resort: 'Station',
                ayurvedaWellness: 'Bien-être Ayurveda',
                packages: 'Forfaits',
                contactUs: 'Contact',
            },
            language: {
                english: 'Anglais',
                german: 'Allemand',
                russian: 'Russe',
                french: 'Français',
                chinese: 'Chinois',
                japanese: 'Japonais',
            },
            villa: {
                title: 'Sun Flower Beach Resort',
                description1: 'Niché le long des côtes dorées du Sri Lanka, le Sun Flower Beach Resort offre une escapade sereine où le bruit des vagues rencontre un confort luxueux. Nos chambres de luxe spacieuses disposent d’équipements modernes et de vues imprenables sur la plage, mêlant élégance contemporaine et charme de la vie côtière pour un séjour inoubliable.',
                description2: 'Les clients peuvent s’adonner à des traitements ayurvédiques authentiques, savourer une cuisine de classe mondiale aux saveurs locales fraîches et se détendre dans une atmosphère conçue pour un confort absolu. Que vous recherchiez une retraite paisible, une escapade romantique ou une aventure au bord de la plage, le Sun Flower Beach Resort est la destination idéale pour répondre à tous vos désirs.',
                imageAlt: 'Vue du Sun Flower Beach Resort',
                roomsTitle: 'Nos chambres doubles de luxe',
                roomsDescription: 'Découvrez le luxe et le confort dans nos chambres avec vue sur la plage, magnifiquement conçues, au Sun Flower Beach Resort. Que vous voyagiez seul, en couple ou en famille, nous offrons l’hébergement de luxe parfait pour rendre votre escapade balnéaire vraiment inoubliable.',
                singleRoomTitle: 'Chambres doubles de luxe',
                singleRoomAlt: 'Vue de la chambre double de luxe',
                familyRoomTitle: 'Chambre double de luxe avec vue sur la mer',
                familyRoomAlt: 'Chambre double de luxe avec vue sur la mer',
                viewDetails: 'Voir les détails',
                seaBathTitle: 'Vue sur la mer depuis le resort',
                seaBathDescription1: 'Sortez du Sun Flower Beach Resort et découvrez les sables dorés et les eaux cristallines de l’océan Indien, à seulement quelques pas de votre chambre. Que vous souhaitiez nager, vous promener tranquillement le long du rivage ou simplement profiter du soleil, notre emplacement en bord de plage offre l’évasion parfaite.',
                seaBathDescription2: 'Avec des vagues douces, des vues imprenables sur l’océan et le son de la mer comme bande-son, chaque moment ici ressemble au paradis. Profitez de promenades romantiques au coucher du soleil, dînez en bord de mer sous les étoiles ou essayez des sports nautiques excitants pour une touche d’aventure — tout cela à votre porte au Sun Flower Beach Resort.',
                seaBathAlt: 'Vue sur la mer près du Sun Flower Beach Resort',
                restaurantTitle: 'Notre restaurant',
                restaurantDescription1: 'Surplombant les côtes dorées du Sri Lanka, le restaurant Sun Flower Beach offre une expérience culinaire délicieuse où le doux bruit des vagues complète une cuisine exceptionnelle. Notre cadre attrayant en bord de mer combine la beauté de l’océan avec une hospitalité chaleureuse, créant l’endroit parfait pour savourer chaque bouchée.',
                restaurantDescription2: 'Les clients peuvent déguster des fruits de mer fraîchement préparés, des saveurs authentiques du Sri Lanka et des plats internationaux préparés avec les meilleurs ingrédients locaux. Que ce soit pour un dîner romantique, un rassemblement familial ou un repas détendu au bord de la plage, le restaurant Sun Flower Beach promet un voyage culinaire mémorable au bord de la mer.',
                restaurantImageAlt: 'Vue du restaurant Sun Flower Beach',
            },
            home: {
                videoSection: {
                    title: 'Bienvenue au Sun Flower Beach Resort',
                    description: 'Découvrez la beauté époustouflante de la plage, laissez-vous tenter par nos thérapies ayurvédiques signature et profitez d’une escapade véritablement régénérante au bord de l’océan.',
                    resortLabel: 'Station',
                    ayurvedaLabel: 'Ayurveda',
                    restaurantLabel: 'Restaurant',
                    beachLabel: 'Plage',
                },
                heroSection: {
                    subtitle: 'Sun Flower Beach Resort',
                    title: 'L’expérience balnéaire parfaite',
                    description: 'Le Sun Flower Beach Resort est une escapade sereine nichée le long de la côte sud du Sri Lanka. Ce havre accueillant offre des vues imprenables sur l’océan, des hébergements confortables, une cuisine délicieuse et des expériences balnéaires inoubliables. Parfait pour la détente et l’aventure, où l’hospitalité chaleureuse rencontre la beauté de la mer.',
                },
                benefitsSection: {
                    subtitle: 'Moments à chérir',
                    title: 'Profitez d’avantages exclusifs',
                    benefit1: 'Tarifs imbattables',
                    benefit2: 'Profitez ensemble : Plaisir adapté aux familles',
                    benefit3: 'Dîner avec la brise océanique',
                    benefit4: 'Hospitalité sur mesure pour des moments inoubliables',
                    bookNow: 'Réservez maintenant',
                },
                villaSpaSection: {
                    title: 'Sun Flower Beach Resort',
                    description1: 'Découvrez la sérénité au Sun Flower Beach Resort, où le luxe balnéaire se fond harmonieusement avec le charme de la nature. Profitez d’un sanctuaire paisible au bord de l’océan, parfait pour se détendre et revitaliser vos sens.',
                    description2: 'Notre spa ayurvédique propose des rituels de guérison authentiques, combinant des thérapies traditionnelles et des remèdes à base de plantes naturelles pour apaiser votre corps et votre esprit.',
                    description3: 'Qu’il s’agisse de vacances relaxantes, d’une retraite de bien-être holistique ou d’une escapade indulgente, le Sun Flower Beach Resort promet des soins exceptionnels et des expériences inoubliables.',
                    imageAlt1: 'Vue du Sun Flower Beach Resort',
                    imageAlt2: 'Vue de la piscine du Sun Flower Beach Resort',
                },
                apartmentsSection: {
                    title1: 'Chambres doubles de luxe',
                    description1: 'Découvrez nos chambres doubles de luxe élégamment aménagées, dotées d’équipements de premier ordre et de vues panoramiques époustouflantes.',
                    title2: 'Chambre double de luxe avec vue sur la mer',
                    description2: 'Séjournez dans une chambre double de luxe avec vue sur la mer, offrant un mélange parfait de confort, d’exclusivité et d’élégance moderne.',
                    viewMore: 'Voir plus',
                    imageAlt1: 'Vue de la chambre double de luxe',
                    imageAlt2: 'Chambre double de luxe avec vue sur la mer',
                },
                ayurvedaSection: {
                    title: 'Bien-être Ayurveda',
                    description1: 'Au Sun Flower Beach Resort Ayurveda Wellness, nous célébrons l’art de la régénération. Nos thérapies combinent les traditions ayurvédiques anciennes avec des pratiques de bien-être modernes, offrant une expérience de guérison holistique qui apporte l’harmonie à votre corps et votre esprit.',
                    description2: 'Plongez dans nos traitements spa signature, thérapies à base de plantes et sessions de méditation conçues pour vous aider à retrouver votre paix intérieure. Que vous cherchiez à soulager le stress ou à détoxifier, nous offrons une retraite de bien-être inégalée.',
                    viewTreatments: 'Voir nos traitements',
                    imageAlt: 'Vue du spa ayurvédique du Sun Flower Beach Resort',
                },
                villaSection: {
                    title: 'Sun Flower Beach Resort',
                    description1: 'Le Sun Flower Beach Resort offre un mélange parfait de détente, de confort et de charme tropical. Niché au bord de l’océan, il propose une escapade idyllique pour les familles, les couples ou les groupes à la recherche d’un séjour paisible au bord de la mer.',
                    description2: 'Avec des espaces magnifiquement conçus, des vues imprenables sur l’océan et une hospitalité chaleureuse, le resort offre une expérience exceptionnelle. Que vous vous détendiez sur la plage, savouriez une cuisine locale fraîche ou profitiez de traitements de bien-être régénérants, le Sun Flower Beach Resort promet un séjour véritablement mémorable.',
                    viewRooms: 'Voir nos chambres',
                    imageAlt: 'Vue du Sun Flower Beach Resort',
                },
                reviewsSection: {
                    title: 'Avis des clients',
                },
                gallerySection: {
                    title: 'Notre galerie',
                    noImages: 'Aucune image disponible pour cette section',
                    error: 'Échec du chargement des éléments de la galerie',
                    sectionLabels: {
                        All: 'Tous',
                        Resort: 'Station',
                        Ayurveda: 'Ayurveda',
                        Restaurant: 'Restaurant',
                        Beach: 'Plage',
                    },
                },
                contactSection: {
                    title: 'Contactez-nous',
                    description: 'Nous sommes là pour vous ! Que vous soyez curieux de nos offres, prêt à réserver votre séjour ou simplement désireux de vous connecter, n’hésitez pas à nous contacter à tout moment.',
                    contactUs: 'Contactez-nous',
                },
            },
            aboutUs: {
                introSection: {
                    title: 'Bienvenue au Sun Flower Beach Resort !',
                    description: 'Le Sun Flower Beach Resort vous invite à vous évader dans un monde de sérénité côtière et de guérison naturelle. Niché sur les côtes ensoleillées du Sri Lanka, le resort allie confort moderne et traditions ancestrales de bien-être. Découvrez le pouvoir apaisant des traitements ayurvédiques authentiques dans notre spa tranquille, détendez-vous dans des chambres élégamment conçues qui reflètent le charme de l’île, et savourez une cuisine nutritive élaborée à partir d’ingrédients locaux frais. Que vous commenciez votre journée avec du yoga au bord de l’océan ou que vous vous détendiez avec un massage aux herbes, chaque moment est conçu pour rétablir l’équilibre et la paix. Le Sun Flower Beach Resort est plus qu’un simple séjour — c’est un voyage vers le bien-être, la culture et la beauté côtière.',
                    learnMore: 'En savoir plus',
                    seeVideo: 'Voir la vidéo',
                    carouselImageAlt1: 'Vue du Sun Flower Beach Resort 1',
                    carouselImageAlt2: 'Vue du Sun Flower Beach Resort 2',
                    carouselImageAlt3: 'Vue du Sun Flower Beach Resort 3',
                    carouselImageAlt4: 'Vue du spa ayurvédique',
                    carouselImageAlt5: 'Vue du Sun Flower Beach Resort 5',
                },
                eventsSection: {
                    title: 'Derniers événements',
                    error: 'Échec du chargement des événements',
                    noEvents: 'Aucun événement disponible pour le moment.',
                    noDate: 'N/A',
                    noDescription: 'Aucune description disponible',
                    noImages: 'Aucune image disponible',
                    table: {
                        eventName: 'Nom de l’événement',
                        date: 'Date',
                        description: 'Description',
                        images: 'Images',
                    },
                    eventImageAlt: 'Vue de l’événement {eventName} {index}',
                },
            },
            contactUs: {
                introSection: {
                    subtitle: 'Sun Flower Beach Resort',
                    title: 'Contactez-nous',
                    description1: 'Merci de nous contacter ! Vos demandes sont importantes pour nous, et nous apprécions votre intérêt pour nos produits/services.',
                    description2: 'Notre équipe dévouée est disponible pour vous aider en semaine de 8h30 à 17h00 (GMT+5:30) et le samedi de 8h30 à 12h30 (GMT+5:30). Soyez assuré que nous nous engageons à répondre rapidement à vos demandes pendant ces heures.',
                },
                formSection: {
                    subtitle: 'Formulaire de contact',
                    title: 'N’HÉSITEZ PAS À NOUS CONTACTER',
                },
                form: {
                    namePlaceholder: 'Votre nom',
                    phonePlaceholder: 'Votre téléphone',
                    emailPlaceholder: 'Votre email',
                    subjectPlaceholder: 'Sujet',
                    messagePlaceholder: 'Votre message',
                    termsLabel: 'J’accepte les Conditions Générales',
                    submitButton: 'ENVOYEZ VOTRE MESSAGE MAINTENANT',
                    whatsappMessage: 'Nom : {{name}}\nTéléphone : {{phone}}\nEmail : {{email}}\nSujet : {{subject}}\nMessage : {{message}}',
                },
                corporateSection: {
                    subtitle: 'Contact professionnel',
                    title: 'Sun Flower Beach Resort et Ayurveda Wellness',
                    address: '221, 7th Lane, Moragalla, Beruwala',
                    telLabel: 'Tél',
                    emailLabel: 'Email',
                },
                locationSection: {
                    title: 'Notre emplacement',
                    mapTitle: 'Carte de localisation',
                },
            },
            apartmentsSection: {
                subtitle: 'Élégantes et confortables, nos chambres doubles de luxe promettent un séjour relaxant.',
                title1: 'Chambres doubles de luxe',
                aboutTitle: 'À propos de nos chambres de luxe',
                description1: 'Nos chambres doubles de luxe offrent une retraite élégante et relaxante, parfaite pour les couples ou les voyageurs en quête de confort au bord de la mer. Chaque chambre dispose d’un lit king-size moelleux, d’une salle de bain moderne avec des équipements haut de gamme et d’une climatisation complète pour un séjour frais et reposant. Conçues avec style et commodité à l’esprit, elles offrent l’espace idéal pour une expérience inoubliable.',
                feature1: '✔ Lit king-size avec literie haut de gamme',
                feature2: '✔ Wi-Fi gratuit à haut débit',
                feature3: '✔ Service de chambre et concierge 24/7',
                feature4: '✔ Salles de bain attenantes',
                feature5: '✔ Entièrement climatisé',
                feature6: '✔ Coin pour préparer le thé',
                bookNow: 'Réservez maintenant',
                bookNowMessage: 'Bonjour, je souhaite réserver une chambre double de luxe au Sun Flower Beach Resort. Pouvez-vous fournir plus de détails ?',
                imageAlt1: 'Vue de la chambre double de luxe',
                subtitleSeaView: 'Chambre double de luxe avec une vue imprenable sur la mer.',
                title2: 'Chambre double de luxe avec vue sur la mer',
                aboutTitleSeaView: 'À propos de la chambre double de luxe avec vue sur la mer',
                description2: 'Nos chambres doubles de luxe avec vue sur la mer offrent un mélange parfait d’élégance et de confort, conçues pour créer un séjour relaxant et mémorable. Chaque chambre dispose d’un lit king-size moelleux pour des nuits reposantes, d’une salle de bain spacieuse avec des équipements haut de gamme et d’une climatisation complète pour votre confort. Profitez de vues imprenables sur la mer qui ajoutent une toile de fond sereine à votre séjour. Idéale pour les couples ou les voyageurs en solo à la recherche d’une retraite élégante au bord de l’océan, cette chambre combine des commodités modernes avec un paysage à couper le souffle pour une expérience inoubliable.',
                bookNowMessageSeaView: 'Bonjour, je souhaite réserver une chambre double de luxe avec vue sur la mer au Sun Flower Beach Resort. Pouvez-vous fournir plus de détails ?',
                imageAlt2: 'Chambre double de luxe avec vue sur la mer',
            },
            spaSection: {
                title: 'Bien-être ayurvédique du Sun Flower Beach Resort',
                description: 'Au Sun Flower Beach Resort, plongez dans l’art de la guérison avec nos expériences authentiques de bien-être ayurvédique. Niché au bord de l’océan, notre spa paisible propose des thérapies ancestrales conçues pour rajeunir votre esprit, votre corps et votre âme. Des massages apaisants aux huiles herbales aux traitements revitalisants adaptés à vos besoins, chaque séance est conçue pour rétablir l’équilibre, renforcer la vitalité et vous laisser un sentiment de renouveau total.',
                treatmentsTitle: 'Nos traitements ayurvédiques',
                viewMore: 'Voir plus',
                enlargedImageAlt: 'Vue agrandie du traitement',
                closeEnlargedImage: 'Fermer l’image agrandie',
                closeModal: 'Fermer',
                previousImage: 'Précédent',
                nextImage: 'Suivant',
                descriptionTitle: 'Description',
                benefitsTitle: 'Bienfaits pour la santé',
                noDescription: 'Aucune description disponible.',
                noBenefits: 'Aucun bienfait répertorié.',
                defaultTreatmentName: 'Traitement',
                treatments: {
                    shirodhara: {
                        name: 'Shirodhara',
                        description: 'Un versement doux d’huile herbale chaude sur le front pour calmer l’esprit.',
                        benefits: [
                            'Réduit le stress et l’anxiété',
                            'Favorise un meilleur sommeil',
                            'Améliore la clarté mentale',
                        ],
                    },
                    steamBath: {
                        name: 'Bain de vapeur',
                        description: 'Un traitement à la vapeur détoxifiant pour ouvrir les pores et détendre les muscles.',
                        benefits: [
                            'Détoxifie le corps',
                            'Améliore la circulation',
                            'Soulage la tension musculaire',
                        ],
                    },
                    flowerBath: {
                        name: 'Bain de fleurs',
                        description: 'Un bain apaisant infusé de fleurs aromatiques pour la relaxation.',
                        benefits: [
                            'Calme le système nerveux',
                            'Hydrate la peau',
                            'Améliore l’humeur',
                        ],
                    },
                    headMassage: {
                        name: 'Massage de la tête',
                        description: 'Un massage relaxant ciblant le cuir chevelu pour soulager les tensions.',
                        benefits: [
                            'Réduit les maux de tête',
                            'Améliore la santé du cuir chevelu',
                            'Favorise la relaxation',
                        ],
                    },
                    faceMassage: {
                        name: 'Massage du visage',
                        description: 'Un massage rajeunissant pour améliorer l’éclat du visage et réduire le stress.',
                        benefits: [
                            'Améliore le teint de la peau',
                            'Réduit la tension faciale',
                            'Favorise le drainage lymphatique',
                        ],
                    },
                    neckMassage: {
                        name: 'Massage du cou',
                        description: 'Massage ciblé pour soulager la raideur et la tension du cou.',
                        benefits: [
                            'Soulage les douleurs cervicales',
                            'Améliore la flexibilité',
                            'Réduit le stress',
                        ],
                    },
                    shoulderMassage: {
                        name: 'Massage des épaules',
                        description: 'Massage ciblé pour soulager la raideur et l’inconfort des épaules.',
                        benefits: [
                            'Réduit les douleurs aux épaules',
                            'Améliore la posture',
                            'Détend les muscles',
                        ],
                    },
                    bodyMassage: {
                        name: 'Massage corporel',
                        description: 'Un massage complet du corps pour favoriser la relaxation et le bien-être général.',
                        benefits: [
                            'Améliore la circulation',
                            'Soulage les douleurs musculaires',
                            'Favorise la relaxation',
                        ],
                    },
                    backMassage: {
                        name: 'Massage du dos',
                        description: 'Un massage thérapeutique ciblant les douleurs et tensions du dos.',
                        benefits: [
                            'Soulage les douleurs dorsales',
                            'Améliore la santé de la colonne vertébrale',
                            'Réduit le stress',
                        ],
                    },
                    footMassage: {
                        name: 'Massage des pieds',
                        description: 'Un massage apaisant pour soulager les douleurs des pieds et favoriser la relaxation.',
                        benefits: [
                            'Améliore la circulation',
                            'Réduit la fatigue des pieds',
                            'Favorise la relaxation',
                        ],
                    },
                },
            },
            packagesSection: {
                title: 'Nos forfaits',
                loadingMessage: 'Chargement des forfaits...',
                errorMessage: 'Échec du chargement des forfaits. Veuillez réessayer plus tard.',
                viewDetails: 'Voir les détails',
                bookNow: 'Réserver via WhatsApp',
                descriptionTitle: 'Description',
                featuresTitle: 'Caractéristiques',
                imageAlt: 'Image du forfait {packageName}',
                modalContentLabel: 'Détails du forfait',
                closeModal: 'Fermer',
                bookNowMessage: 'Bonjour ! Je souhaite réserver le forfait {packageName}.\n\nDétails du forfait :\n{description}\n\nCaractéristiques :\n{features}',
            },
            footerSection: {
                logoAlt: 'Logo du Sun Flower Beach Resort',
                resortTitle: 'Sun Flower Beach Resort',
                links: {
                    home: 'Accueil',
                    aboutUs: 'À propos de nous',
                    resort: 'Resort',
                    ayurvedaWellness: 'Bien-être ayurvédique',
                    packages: 'Forfaits',
                    contactUs: 'Contactez-nous',
                },
                getInTouchTitle: 'Contactez-nous',
                address: '6th Lane, Police Bungalow Rd, Beruwala, Sri Lanka',
                email: 'sunflower.beruwala@gmail.com',
                phone: '+94 77 534 0670',
                stayConnectedTitle: 'Restez connecté',
                emailPlaceholder: 'Entrez votre email',
                socialMedia: {
                    facebook: 'Suivez-nous sur Facebook',
                    instagram: 'Suivez-nous sur Instagram',
                    youtube: 'Suivez-nous sur YouTube',
                    twitter: 'Suivez-nous sur Twitter',
                },
                copyright: '© 2025 Sun Flower Beach Resort. Tous droits réservés.',
                developedBy: {
                    text: 'Site web conçu et développé par Redev Solutions',
                    phone: '+94 76 460 8225',
                },
            },
        },
    },
    zh: {
        translation: {
            navbar: {
                home: '首页',
                aboutUs: '关于我们',
                resort: '度假村',
                ayurvedaWellness: '阿育吠陀健康',
                packages: '套餐',
                contactUs: '联系我们',
            },
            language: {
                english: '英语',
                german: '德语',
                russian: '俄语',
                french: '法语',
                chinese: '中文',
                japanese: '日语',
            },
            villa: {
                title: 'Sun Flower Beach 度假村',
                description1: 'Sun Flower Beach 度假村坐落在斯里兰卡的黄金海岸旁，提供了一个宁静的避风港，波浪的声音与奢华的舒适相遇。我们的宽敞豪华客房配备现代设施和令人叹为观止的海滩景观，将当代优雅与海岸生活的魅力融合，带来难忘的住宿体验。',
                description2: '宾客可以享受正宗的阿育吠陀治疗，品尝使用新鲜当地食材烹制的世界级美食，并在专为纯粹舒适设计的氛围中放松。无论您是寻求平静的休养、浪漫的度假，还是海滨冒险，Sun Flower Beach 度假村都是满足您所有愿望的完美目的地。',
                imageAlt: 'Sun Flower Beach 度假村景观',
                roomsTitle: '我们的豪华双人房',
                roomsDescription: '在 Sun Flower Beach 度假村，体验我们精心设计的海景客房的奢华与舒适。无论您是独自旅行、情侣出游还是家庭度假，我们提供完美的豪华住宿，让您的海滨之旅真正难忘。',
                singleRoomTitle: '豪华双人房',
                singleRoomAlt: '豪华双人房景观',
                familyRoomTitle: '豪华海景双人房',
                familyRoomAlt: '豪华海景双人房',
                viewDetails: '查看详情',
                seaBathTitle: '度假村前的海景',
                seaBathDescription1: '走出 Sun Flower Beach 度假村，您将迎接印度洋的金色沙滩和清澈海水，距离您的房间仅几步之遥。无论您想畅游一番、在海边悠闲漫步，还是只是沐浴阳光，我们的海滨位置提供了完美的避风港。',
                seaBathDescription2: '伴随着柔和的波浪、迷人的海景和海的声音作为背景音乐，这里的每一刻都仿佛是天堂。享受浪漫的日落漫步，在星空下体验海滨用餐，或尝试激动人心的水上运动，增添一丝冒险——这一切都在 Sun Flower Beach 度假村触手可及。',
                seaBathAlt: 'Sun Flower Beach 度假村附近的海景',
                restaurantTitle: '我们的餐厅',
                restaurantDescription1: 'Sun Flower Beach 餐厅俯瞰斯里兰卡的黄金海岸，提供令人愉悦的用餐体验，海浪的轻柔声响与卓越的美食相得益彰。我们迷人的海滨环境将海洋之美与热情好客相结合，打造出品尝每一口的完美场所。',
                restaurantDescription2: '宾客可以享用新鲜烹制的海鲜、正宗的斯里兰卡风味和用最好的当地食材制作的国际菜肴。无论是浪漫的晚餐、家庭聚会还是海滨的轻松用餐，Sun Flower Beach 餐厅都承诺带来一场难忘的海边美食之旅。',
                restaurantImageAlt: 'Sun Flower Beach 餐厅景观',
            },
            home: {
                videoSection: {
                    title: '欢迎体验 Sun Flower Beach 度假村',
                    description: '探索海滩的惊艳美景，沉浸于我们标志性的阿育吠陀疗法，享受海洋边真正的焕新之旅。',
                    resortLabel: '度假村',
                    ayurvedaLabel: '阿育吠陀',
                    restaurantLabel: '餐厅',
                    beachLabel: '海滩',
                },
                heroSection: {
                    subtitle: 'Sun Flower Beach 度假村',
                    title: '完美的海滨体验',
                    description: 'Sun Flower Beach 度假村是斯里兰卡南部海岸线上的宁静避风港。这个热情的绿洲提供令人叹为观止的海洋景观、舒适的住宿、美味的餐饮和难忘的海滨体验。适合放松与冒险，热情好客与海洋之美相得益彰。',
                },
                benefitsSection: {
                    subtitle: '珍贵的时刻',
                    title: '享受独特优势',
                    benefit1: '无与伦比的价格',
                    benefit2: '共同欢乐：家庭友好娱乐',
                    benefit3: '伴随海风用餐',
                    benefit4: '为难忘时刻量身定制的款待',
                    bookNow: '立即预订',
                },
                villaSpaSection: {
                    title: 'Sun Flower Beach 度假村',
                    description1: '在 Sun Flower Beach 度假村发现宁静，海滨奢华与自然魅力无缝融合。享受海洋边的宁静庇护所，完美适合放松和焕活您的感官。',
                    description2: '我们的阿育吠陀水疗中心提供正宗的治疗仪式，结合传统疗法和天然草药疗法，舒缓您的身心。',
                    description3: '无论是放松的假期、全面的健康之旅，还是纵情享受的逃离，Sun Flower Beach 度假村承诺卓越的关怀和难忘的体验。',
                    imageAlt1: 'Sun Flower Beach 度假村景观',
                    imageAlt2: 'Sun Flower Beach 度假村泳池景观',
                },
                apartmentsSection: {
                    title1: '豪华双人房',
                    description1: '体验我们优雅布置的豪华双人房，配备顶级设施和壮丽的风景视野。',
                    title2: '豪华海景双人房',
                    description2: '入住豪华海景双人房，完美融合舒适、独特性和现代优雅。',
                    viewMore: '查看更多',
                    imageAlt1: '豪华双人房景观',
                    imageAlt2: '豪华海景双人房',
                },
                ayurvedaSection: {
                    title: '阿育吠陀健康',
                    description1: '在 Sun Flower Beach 度假村阿育吠陀健康中心，我们庆祝焕新的艺术。我们的疗法结合古老的阿育吠陀传统与现代健康实践，提供全面的治疗体验，为您的身心带来和谐。',
                    description2: '沉浸于我们标志性的水疗护理、草药疗法和冥想课程，旨在帮助您重新连接内心的平静。无论您寻求缓解压力还是排毒，我们提供无与伦比的健康之旅。',
                    viewTreatments: '查看我们的疗法',
                    imageAlt: 'Sun Flower Beach 度假村阿育吠陀水疗景观',
                },
                villaSection: {
                    title: 'Sun Flower Beach 度假村',
                    description1: 'Sun Flower Beach 度假村提供放松、舒适和热带魅力的完美融合。坐落在海洋边，它为家庭、情侣或团体提供了一个寻求宁静海滨度假的理想避风港。',
                    description2: '凭借精美的设计空间、壮丽的海洋景观和热情的款待，度假村带来卓越的体验。无论您在海滩上休闲、品尝新鲜的当地美食，还是享受焕新的健康护理，Sun Flower Beach 度假村承诺一个真正难忘的住宿。',
                    viewRooms: '查看我们的房间',
                    imageAlt: 'Sun Flower Beach 度假村景观',
                },
                reviewsSection: {
                    title: '客人评价',
                },
                gallerySection: {
                    title: '我们的画廊',
                    noImages: '此部分没有可用的图片',
                    error: '无法获取画廊项目',
                    sectionLabels: {
                        All: '全部',
                        Resort: '度假村',
                        Ayurveda: '阿育吠陀',
                        Restaurant: '餐厅',
                        Beach: '海滩',
                    },
                },
                contactSection: {
                    title: '与我们联系',
                    description: '我们随时为您服务！无论您对我们的服务感到好奇、准备预订您的住宿，还是只是想联系我们，随时与我们取得联系。',
                    contactUs: '联系我们',
                },
            },
            aboutUs: {
                introSection: {
                    title: '欢迎体验 Sun Flower Beach 度假村！',
                    description: 'Sun Flower Beach 度假村邀请您逃离到一个充满海岸宁静和自然疗愈的世界。度假村坐落在斯里兰卡阳光普照的海岸边，融合了现代舒适与古老的健康传统。在我们宁静的水疗中心体验正宗阿育吠陀治疗的舒缓力量，放松在反映岛屿魅力的精心设计的房间中，品尝由新鲜当地食材烹制的营养美食。无论是清晨在海边练习瑜伽，还是以草药按摩放松身心，每一刻都旨在恢复平衡与平静。Sun Flower Beach 度假村不仅仅是住宿——它是一场通往健康、文化和海岸美景的旅程。',
                    learnMore: '了解更多',
                    seeVideo: '观看视频',
                    carouselImageAlt1: 'Sun Flower Beach 度假村景观 1',
                    carouselImageAlt2: 'Sun Flower Beach 度假村景观 2',
                    carouselImageAlt3: 'Sun Flower Beach 度假村景观 3',
                    carouselImageAlt4: '阿育吠陀水疗景观',
                    carouselImageAlt5: 'Sun Flower Beach 度假村景观 5',
                },
                eventsSection: {
                    title: '最新活动',
                    error: '无法获取活动',
                    noEvents: '目前没有可用的活动。',
                    noDate: '无日期',
                    noDescription: '无描述',
                    noImages: '无可用图片',
                    table: {
                        eventName: '活动名称',
                        date: '日期',
                        description: '描述',
                        images: '图片',
                    },
                    eventImageAlt: '活动 {eventName} 视图 {index}',
                },
            },
            contactUs: {
                introSection: {
                    subtitle: 'Sun Flower Beach 度假村',
                    title: '联系我们',
                    description1: '感谢您联系我们！您的咨询对我们非常重要，我们感谢您对我们产品/服务的兴趣。',
                    description2: '我们的专业团队在工作日的上午8:30至下午5:00 (GMT+5:30) 以及周六的上午8:30至中午12:30 (GMT+5:30) 为您提供帮助。请放心，我们致力于在这些时间段内快速响应您的咨询。',
                },
                formSection: {
                    subtitle: '联系表格',
                    title: '随时与我们联系',
                },
                form: {
                    namePlaceholder: '您的姓名',
                    phonePlaceholder: '您的电话',
                    emailPlaceholder: '您的电子邮件',
                    subjectPlaceholder: '主题',
                    messagePlaceholder: '您的消息',
                    termsLabel: '我接受条款和条件',
                    submitButton: '立即发送您的消息',
                    whatsappMessage: '姓名：{{name}}\n电话：{{phone}}\n电子邮件：{{email}}\n主题：{{subject}}\n消息：{{message}}',
                },
                corporateSection: {
                    subtitle: '企业联系方式',
                    title: 'Sun Flower Beach 度假村和 Ayurveda 健康中心',
                    address: '221, 7th Lane, Moragalla, Beruwala',
                    telLabel: '电话',
                    emailLabel: '电子邮件',
                },
                locationSection: {
                    title: '我们的位置',
                    mapTitle: '位置地图',
                },
            },
            apartmentsSection: {
                subtitle: '时尚而舒适，我们的豪华双人房承诺为您带来放松的住宿体验。',
                title1: '豪华双人房',
                aboutTitle: '关于我们的豪华客房',
                description1: '我们的豪华双人房提供了一个优雅而放松的避风港，非常适合寻求海边舒适的情侣或旅行者。每间客房均配有豪华的king-size床、配备高级设施的现代化浴室以及全套空调，确保凉爽、宁静的住宿体验。设计兼顾风格与便利，提供一个令人难忘的完美空间。',
                feature1: '✔ 配备高级床品的king-size床',
                feature2: '✔ 高速免费Wi-Fi',
                feature3: '✔ 24/7客房服务和礼宾服务',
                feature4: '✔ 附带浴室',
                feature5: '✔ 全程空调',
                feature6: '✔ 茶水制作区',
                bookNow: '立即预订',
                bookNowMessage: '您好，我想在Sun Flower Beach度假村预订一间豪华双人房。可以提供更多细节吗？',
                imageAlt1: '豪华双人房景观',
                subtitleSeaView: '豪华双人房，享有令人叹为观止的海景。',
                title2: '豪华海景双人房',
                aboutTitleSeaView: '关于豪华海景双人房',
                description2: '我们的豪华海景双人房提供优雅与舒适的完美融合，旨在打造一个放松而难忘的住宿体验。每间客房均配有豪华的king-size床，确保安稳的夜晚，宽敞的浴室配备高级设施，以及全套空调为您的舒适提供保障。享受令人惊叹的海景，为您的住宿增添宁静的背景。非常适合寻求海洋边时尚度假的情侣或独旅行者，这间客房将现代设施与壮丽的景色相结合，带来难忘的体验。',
                bookNowMessageSeaView: '您好，我想在Sun Flower Beach度假村预订一间豪华海景双人房。可以提供更多细节吗？',
                imageAlt2: '豪华海景双人房',
            },
            spaSection: {
                title: 'Sun Flower Beach Resort阿育吠陀健康中心',
                description: '在Sun Flower Beach Resort，沉浸在我们正宗的阿育吠陀健康体验中，感受治愈的艺术。我们宁静的水疗中心坐落于海洋旁，提供古老的疗法，旨在让您的身心和灵魂焕发活力。从舒缓的草药油按摩到根据您的需求量身定制的焕活疗程，每一个疗程都旨在恢复平衡、增强活力，让您感觉彻底焕然一新。',
                treatmentsTitle: '我们的阿育吠陀疗程',
                viewMore: '查看更多',
                enlargedImageAlt: '疗程放大视图',
                closeEnlargedImage: '关闭放大图片',
                closeModal: '关闭',
                previousImage: '上一张',
                nextImage: '下一张',
                descriptionTitle: '描述',
                benefitsTitle: '健康益处',
                noDescription: '无描述可用。',
                noBenefits: '未列出益处。',
                defaultTreatmentName: '疗程',
                treatments: {
                    shirodhara: {
                        name: '头部油疗',
                        description: '将温热的草药油轻轻倒在前额上，以平静心神。',
                        benefits: [
                            '减轻压力和焦虑',
                            '促进更好的睡眠',
                            '增强心理清晰度',
                        ],
                    },
                    steamBath: {
                        name: '蒸汽浴',
                        description: '一种排毒的蒸汽疗程，用于打开毛孔和放松肌肉。',
                        benefits: [
                            '排毒身体',
                            '改善血液循环',
                            '缓解肌肉紧张',
                        ],
                    },
                    flowerBath: {
                        name: '花浴',
                        description: '一种注入芳香花朵的舒缓浴，用于放松。',
                        benefits: [
                            '平静神经系统',
                            '滋润皮肤',
                            '提升心情',
                        ],
                    },
                    headMassage: {
                        name: '头部按摩',
                        description: '一种针对头皮的放松按摩，用于缓解紧张。',
                        benefits: [
                            '减轻头痛',
                            '改善头皮健康',
                            '促进放松',
                        ],
                    },
                    faceMassage: {
                        name: '面部按摩',
                        description: '一种焕活的按摩，用于增强面部光泽和减轻压力。',
                        benefits: [
                            '改善肤色',
                            '减轻面部紧张',
                            '促进淋巴引流',
                        ],
                    },
                    neckMassage: {
                        name: '颈部按摩',
                        description: '针对颈部僵硬和紧张的集中按摩。',
                        benefits: [
                            '缓解颈部疼痛',
                            '提高灵活性',
                            '减轻压力',
                        ],
                    },
                    shoulderMassage: {
                        name: '肩部按摩',
                        description: '针对肩部僵硬和不适的集中按摩。',
                        benefits: [
                            '减轻肩部疼痛',
                            '改善姿势',
                            '放松肌肉',
                        ],
                    },
                    bodyMassage: {
                        name: '全身按摩',
                        description: '一种促进整体放松和健康的全面按摩。',
                        benefits: [
                            '增强血液循环',
                            '缓解肌肉酸痛',
                            '促进放松',
                        ],
                    },
                    backMassage: {
                        name: '背部按摩',
                        description: '一种针对背部疼痛和紧张的治疗性按摩。',
                        benefits: [
                            '缓解背部疼痛',
                            '改善脊柱健康',
                            '减轻压力',
                        ],
                    },
                    footMassage: {
                        name: '足部按摩',
                        description: '一种舒缓的按摩，用于缓解足部疼痛和促进放松。',
                        benefits: [
                            '改善血液循环',
                            '减轻足部疲劳',
                            '促进放松',
                        ],
                    },
                },
            },
            packagesSection: {
                title: '我们的套餐',
                loadingMessage: '正在加载套餐...',
                errorMessage: '无法加载套餐。请稍后再试。',
                viewDetails: '查看详情',
                bookNow: '通过WhatsApp预订',
                descriptionTitle: '描述',
                featuresTitle: '特色',
                imageAlt: '{packageName}套餐图片',
                modalContentLabel: '套餐详情',
                closeModal: '关闭',
                bookNowMessage: '您好！我想预订{packageName}套餐。\n\n套餐详情：\n{description}\n\n特色：\n{features}',
            },
            footerSection: {
                logoAlt: 'Sun Flower Beach Resort标志',
                resortTitle: 'Sun Flower Beach Resort',
                links: {
                    home: '首页',
                    aboutUs: '关于我们',
                    resort: '度假村',
                    ayurvedaWellness: '阿育吠陀健康',
                    packages: '套餐',
                    contactUs: '联系我们',
                },
                getInTouchTitle: '联系方式',
                address: '斯里兰卡贝鲁瓦拉警察平房路6巷',
                email: 'sunflower.beruwala@gmail.com',
                phone: '+94 77 534 0670',
                stayConnectedTitle: '保持联系',
                emailPlaceholder: '输入您的邮箱',
                socialMedia: {
                    facebook: '在Facebook上关注我们',
                    instagram: '在Instagram上关注我们',
                    youtube: '在YouTube上关注我们',
                    twitter: '在Twitter上关注我们',
                },
                copyright: '© 2025 Sun Flower Beach Resort。保留所有权利。',
                developedBy: {
                    text: '网站由Redev Solutions设计和开发',
                    phone: '+94 76 460 8225',
                },
            },
        },
    },
    ja: {
        translation: {
            navbar: {
                home: 'ホーム',
                aboutUs: '私たちについて',
                resort: 'リゾート',
                ayurvedaWellness: 'アーユルヴェーダウェルネス',
                packages: 'パッケージ',
                contactUs: 'お問い合わせ',
            },
            language: {
                english: '英語',
                german: 'ドイツ語',
                russian: 'ロシア語',
                french: 'フランス語',
                chinese: '中国語',
                japanese: '日本語',
            },
            villa: {
                title: 'サンフラワービーチリゾート',
                description1: 'スリランカの黄金の海岸沿いに位置するサンフラワービーチリゾートは、波の音と豪華な快適さが融合する静かな隠れ家を提供します。広々とした高級客室にはモダンな設備と息をのむようなビーチの景色が備わり、現代的なエレガンスと海岸の生活の魅力が組み合わさった忘れられない滞在をお届けします。',
                description2: 'ゲストは本格的なアーユルヴェーダトリートメントを楽しみ、新鮮な地元の風味を取り入れた世界クラスのダイニングを味わい、純粋な快適さのために設計された雰囲気でリラックスできます。静かなリトリート、ロマンチックな休暇、またはビーチサイドの冒険をお求めの場合、サンフラワービーチリゾートはすべてのご希望を叶える完璧な目的地です。',
                imageAlt: 'サンフラワービーチリゾートの景色',
                roomsTitle: 'デラックスダブルルーム',
                roomsDescription: 'サンフラワービーチリゾートで、絶妙にデザインされたビーチビューの客室で贅沢と快適さを体験してください。一人旅、カップル、または家族での旅行に関わらず、ビーチサイドのエスケープを本当に忘れられないものにする完璧な高級宿泊施設を提供します。',
                singleRoomTitle: 'デラックスダブルルーム',
                singleRoomAlt: 'デラックスダブルルームの景色',
                familyRoomTitle: '海の見えるデラックスダブルルーム',
                familyRoomAlt: '海の見えるデラックスダブルルーム',
                viewDetails: '詳細を見る',
                seaBathTitle: 'リゾート前の海の景色',
                seaBathDescription1: 'サンフラワービーチリゾートを出ると、インド洋の黄金の砂浜と透き通った海が部屋からわずか数歩のところにあります。さわやかな泳ぎ、岸辺での静かな散歩、またはただ太陽を楽しみたい場合でも、ビーチフロントのロケーションは完璧な逃避行を提供します。',
                seaBathDescription2: '穏やかな波、息をのむような海の景色、そして海の音をサウンドトラックにして、ここでの瞬間は楽園のようです。ロマンチックな夕暮れの散歩、星空の下でのビーチフロントダイニング、またはエキサイティングなウォータースポーツを試して冒険を味わう—すべてがサンフラワービーチリゾートのすぐそばで楽しめます。',
                seaBathAlt: 'サンフラワービーチリゾート近くの海の景色',
                restaurantTitle: '私たちのレストラン',
                restaurantDescription1: 'スリランカの黄金の海岸を見下ろすサンフラワービーチレストランは、波の穏やかな音が素晴らしい料理を補完する楽しいダイニング体験を提供します。魅力的なビーチフロントの環境は、海洋の美しさと温かいおもてなしを組み合わせて、すべてのひとくちを味わうのに最適な場所を作り出します。',
                restaurantDescription2: 'ゲストは新鮮に調理されたシーフード、本格的なスリランカの風味、そして最高の地元食材で作られた国際的な料理を楽しめます。ロマンチックなディナー、家族の集まり、またはリラックスしたビーチサイドの食事のために、サンフラワービーチレストランは海辺での忘れられない美食の旅を約束します。',
                restaurantImageAlt: 'サンフラワービーチレストランの景色',
            },
            home: {
                videoSection: {
                    title: 'サンフラワービーチリゾートへようこそ',
                    description: 'ビーチの息をのむような美しさを発見し、シグネチャーアーユルヴェーダ療法に浸り、オーシャンサイドでの真にリフレッシュできる休暇を楽しみましょう。',
                    resortLabel: 'リゾート',
                    ayurvedaLabel: 'アーユルヴェーダ',
                    restaurantLabel: 'レストラン',
                    beachLabel: 'ビーチ',
                },
                heroSection: {
                    subtitle: 'サンフラワービーチリゾート',
                    title: '完璧なビーチサイド体験',
                    description: 'サンフラワービーチリゾートは、スリランカの南部海岸線に位置する静かな逃避行です。この歓迎のオアシスは、息をのむようなオーシャンビュー、快適な宿泊施設、美味しい食事、そして忘れられないビーチサイド体験を提供します。リラクゼーションと冒険の両方に最適で、温かいおもてなしが海の美しさと出会います。',
                },
                benefitsSection: {
                    subtitle: '大切な瞬間',
                    title: '特別な特典を享受',
                    benefit1: '無敵の料金',
                    benefit2: '一緒に楽しむ：家族向けの楽しみ',
                    benefit3: 'オーシャンブリーズでのダイニング',
                    benefit4: '忘れられない瞬間のためのカスタマイズされたおもてなし',
                    bookNow: '今すぐ予約',
                },
                villaSpaSection: {
                    title: 'サンフラワービーチリゾート',
                    description1: 'サンフラワービーチリゾートで静けさを発見し、ビーチサイドの贅沢が自然の魅力とシームレスに融合します。海辺の平和な聖域を楽しみ、リラックスして感覚を活性化するのに最適です。',
                    description2: '私たちのアーユルヴェーダスパは、伝統的な療法と天然のハーブ療法を組み合わせた本格的な癒しの儀式を提供し、身体と心を落ち着かせます。',
                    description3: 'リラックスした休暇、ホリスティックなウェルネスリトリート、または贅沢な逃避行のいずれであっても、サンフラワービーチリゾートは卓越したケアと忘れられない体験を約束します。',
                    imageAlt1: 'サンフラワービーチリゾートの景色',
                    imageAlt2: 'サンフラワービーチリゾートのプールの景色',
                },
                apartmentsSection: {
                    title1: 'デラックスダブルルーム',
                    description1: '一流の設備と見事な景観を備えたエレガントに整えられたデラックスダブルルームを体験してください。',
                    title2: '海の見えるデラックスダブルルーム',
                    description2: '快適さ、独自性、モダンなエレガンスが完璧に融合した海の見えるデラックスダブルルームに宿泊してください。',
                    viewMore: 'もっと見る',
                    imageAlt1: 'デラックスダブルルームの景色',
                    imageAlt2: '海の見えるデラックスダブルルーム',
                },
                ayurvedaSection: {
                    title: 'アーユルヴェーダウェルネス',
                    description1: 'サンフラワービーチリゾートアーユルヴェーダウェルネスでは、再生の芸術を祝います。私たちの療法は、古代のアーユルヴェーダの伝統と現代のウェルネス実践を組み合わせ、身体と心に調和をもたらすホリスティックな癒し体験を提供します。',
                    description2: '私たちのシグネチャースパトリートメント、ハーブ療法、瞑想セッションに浸り、内なる平和を再接続するように設計されています。ストレス解消やデトックスを求める場合でも、比類のないウェルネスリトリートを提供します。',
                    viewTreatments: 'トリートメントを見る',
                    imageAlt: 'サンフラワービーチリゾートアーユルヴェーダスパの景色',
                },
                villaSection: {
                    title: 'サンフラワービーチリゾート',
                    description1: 'サンフラワービーチリゾートは、リラクゼーション、快適さ、トロピカルな魅力の完璧な融合を提供します。オーシャンに位置し、家族、カップル、またはグループ向けの平和なビーチサイドの逃避行を提供します。',
                    description2: '美しくデザインされた空間、息をのむようなオーシャンビュー、温かいおもてなしにより、リゾートは卓越した体験を提供します。ビーチでのんびりしたり、新鮮な地元料理を味わったり、再生するウェルネストリートメントを楽しんだり、サンフラワービーチリゾートは本当の意味で思い出に残る滞在を約束します。',
                    viewRooms: '部屋を見る',
                    imageAlt: 'サンフラワービーチリゾートの景色',
                },
                reviewsSection: {
                    title: 'ゲストレビュー',
                },
                gallerySection: {
                    title: '私たちのギャラリー',
                    noImages: 'このセクションに利用可能な画像はありません',
                    error: 'ギャラリーアイテムの取得に失敗しました',
                    sectionLabels: {
                        All: 'すべて',
                        Resort: 'リゾート',
                        Ayurveda: 'アーユルヴェーダ',
                        Restaurant: 'レストラン',
                        Beach: 'ビーチ',
                    },
                },
                contactSection: {
                    title: 'お問い合わせください',
                    description: '私たちはあなたのためにここにいます！私たちのサービスについて知りたい、滞在を予約する準備ができている、またはただつながりたい場合、いつでも気軽にご連絡ください。',
                    contactUs: 'お問い合わせ',
                },
            },
            aboutUs: {
                introSection: {
                    title: 'サンフラワービーチリゾートへようこそ！',
                    description: 'サンフラワービーチリゾートは、沿岸の静けさと自然の癒しの世界へとあなたを誘います。スリランカの陽光に浴した海岸に位置するリゾートは、現代的な快適さと古くからのウェルネスの伝統を融合しています。穏やかなスパでの本格的なアーユルヴェーダトリートメントの癒しの力を発見し、島の魅力を反映した上品にデザインされた部屋でリラックスし、新鮮な地元食材を使った栄養価の高い料理を味わってください。海辺でのヨガで一日を始めたり、ハーブマッサージでくつろいだり、すべての瞬間がバランスと平和を取り戻すように設計されています。サンフラワービーチリゾートは単なる滞在ではなく、ウェルネス、文化、そして沿岸の美しさへの旅です。',
                    learnMore: 'もっと詳しく',
                    seeVideo: 'ビデオを見る',
                    carouselImageAlt1: 'サンフラワービーチリゾートの景色 1',
                    carouselImageAlt2: 'サンフラワービーチリゾートの景色 2',
                    carouselImageAlt3: 'サンフラワービーチリゾートの景色 3',
                    carouselImageAlt4: 'アーユルヴェーダスパの景色',
                    carouselImageAlt5: 'サンフラワービーチリゾートの景色 5',
                },
                eventsSection: {
                    title: '最新イベント',
                    error: 'イベントの取得に失敗しました',
                    noEvents: '現在、利用可能なイベントはありません。',
                    noDate: '該当なし',
                    noDescription: '説明がありません',
                    noImages: '画像がありません',
                    table: {
                        eventName: 'イベント名',
                        date: '日付',
                        description: '説明',
                        images: '画像',
                    },
                    eventImageAlt: 'イベント {eventName} の景色 {index}',
                },
            },
            contactUs: {
                introSection: {
                    subtitle: 'サンフラワービーチリゾート',
                    title: 'お問い合わせ',
                    description1: 'ご連絡ありがとうございます！お客様のご質問は私たちにとって重要であり、弊社の製品/サービスにご興味をお持ちいただき感謝いたします。',
                    description2: '私たちの専任チームは、平日の午前8:30から午後5:00（GMT+5:30）、および土曜日の午前8:30から午後12:30（GMT+5:30）にご対応いたします。これらの時間内に迅速にお客様のご質問に対応することをお約束します。',
                },
                formSection: {
                    subtitle: 'お問い合わせフォーム',
                    title: 'お気軽にご連絡ください',
                },
                form: {
                    namePlaceholder: 'お名前',
                    phonePlaceholder: '電話番号',
                    emailPlaceholder: 'メールアドレス',
                    subjectPlaceholder: '件名',
                    messagePlaceholder: 'メッセージ',
                    termsLabel: '利用規約に同意します',
                    submitButton: '今すぐメッセージを送信',
                    whatsappMessage: '名前：{{name}}\n電話：{{phone}}\nメール：{{email}}\n件名：{{subject}}\nメッセージ：{{message}}',
                },
                corporateSection: {
                    subtitle: '企業連絡先',
                    title: 'サンフラワービーチリゾートとアーユルヴェーダウェルネス',
                    address: '221, 7th Lane, Moragalla, Beruwala',
                    telLabel: '電話',
                    emailLabel: 'メール',
                },
                locationSection: {
                    title: '私たちの所在地',
                    mapTitle: '所在地マップ',
                },
            },
            apartmentsSection: {
                subtitle: 'スタイリッシュで居心地の良いデラックスダブルルームは、リラックスした滞在をお約束します。',
                title1: 'デラックスダブルルーム',
                aboutTitle: 'デラックスルームについて',
                description1: 'デラックスダブルルームは、海辺で快適さを求めるカップルや旅行者に最適なエレガントでリラックスできる隠れ家を提供します。各部屋には豪華なキングサイズベッド、プレミアムな設備を備えたモダンなバスルーム、涼しく休息できる完全なエアコンが備わっています。スタイルと利便性を考慮して設計されており、忘れられない体験のための理想的な空間を提供します。',
                feature1: '✔ プレミアム寝具付きキングサイズベッド',
                feature2: '✔ 高速無料Wi-Fi',
                feature3: '✔ 24時間ルームサービスとコンシェルジュ',
                feature4: '✔ 専用バスルーム',
                feature5: '✔ 完全エアコン完備',
                feature6: '✔ ティーコーナー',
                bookNow: '今すぐ予約',
                bookNowMessage: 'こんにちは、サンフラワービーチリゾートのデラックスダブルルームを予約したいです。詳細を教えてください。',
                imageAlt1: 'デラックスダブルルームの景色',
                subtitleSeaView: '息をのむような海の景色を望むデラックスダブルルーム。',
                title2: '海の見えるデラックスダブルルーム',
                aboutTitleSeaView: '海の見えるデラックスダブルルームについて',
                description2: '海の見えるデラックスダブルルームは、エレガンスと快適さの完璧な融合を提供し、リラックスした忘れられない滞在を創り出します。各部屋には休息の夜のための豪華なキングサイズベッド、プレミアムな設備を備えた広々としたバスルーム、そして快適さのための完全なエアコンが備わっています。滞在に穏やかな背景を加える見事な海の景色をお楽しみください。オーシャンサイドのスタイリッシュな隠れ家を求めるカップルや一人旅に最適で、この部屋はモダンなアメニティと息をのむような景色を組み合わせて、忘れられない体験を提供します。',
                bookNowMessageSeaView: 'こんにちは、サンフラワービーチリゾートの海の見えるデラックスダブルルームを予約したいです。詳細を教えてください。',
                imageAlt2: '海の見えるデラックスダブルルーム',
            },
            spaSection: {
                title: 'サンフラワービーチリゾート アーユルヴェーダウェルネス',
                description: 'サンフラワービーチリゾートでは、本格的なアーユルヴェーダウェルネス体験で癒しの芸術に浸ってください。海のそばに位置する静かなスパでは、心、身体、魂を若返らせる伝統的な療法を提供しています。心地よいハーブオイルマッサージからお客様のニーズに合わせたリバイタライジングトリートメントまで、すべてのセッションはバランスを回復し、活力を高め、真にリフレッシュされた気分にさせるために作られています。',
                treatmentsTitle: '私たちのアーユルヴェーダトリートメント',
                viewMore: 'もっと見る',
                enlargedImageAlt: 'トリートメントの拡大ビュー',
                closeEnlargedImage: '拡大画像を閉じる',
                closeModal: '閉じる',
                previousImage: '前へ',
                nextImage: '次へ',
                descriptionTitle: '説明',
                benefitsTitle: '健康上の利点',
                noDescription: '説明がありません。',
                noBenefits: '利点が記載されていません。',
                defaultTreatmentName: 'トリートメント',
                treatments: {
                    shirodhara: {
                        name: 'シロダーラ',
                        description: '心を落ち着かせるために、温かいハーブオイルを額に優しく流すトリートメント。',
                        benefits: [
                            'ストレスと不安を軽減',
                            'より良い睡眠を促進',
                            '精神的明晰さを高める',
                        ],
                    },
                    steamBath: {
                        name: 'スチームバス',
                        description: '毛穴を開き、筋肉をリラックスさせるデトックススチームトリートメント。',
                        benefits: [
                            '体をデトックス',
                            '血行を改善',
                            '筋肉の緊張を和らげる',
                        ],
                    },
                    flowerBath: {
                        name: 'フラワーバス',
                        description: 'リラクゼーションのための芳香のある花を注入した心地よいバス。',
                        benefits: [
                            '神経系を落ち着かせる',
                            '肌を保湿',
                            '気分を高揚させる',
                        ],
                    },
                    headMassage: {
                        name: 'ヘッドマッサージ',
                        description: '緊張を和らげるために頭皮をターゲットにしたリラックスマッサージ。',
                        benefits: [
                            '頭痛を軽減',
                            '頭皮の健康を改善',
                            'リラクゼーションを促進',
                        ],
                    },
                    faceMassage: {
                        name: 'フェイスマッサージ',
                        description: '顔の輝きを高め、ストレスを軽減するための若返りマッサージ。',
                        benefits: [
                            '肌のトーンを改善',
                            '顔の緊張を軽減',
                            'リンパドレナージを促進',
                        ],
                    },
                    neckMassage: {
                        name: 'ネックマッサージ',
                        description: '首のこわばりと緊張を和らげるための集中的なマッサージ。',
                        benefits: [
                            '首の痛みを軽減',
                            '柔軟性を改善',
                            'ストレスを軽減',
                        ],
                    },
                    shoulderMassage: {
                        name: 'ショルダーマッサージ',
                        description: '肩のこわばりと不快感を和らげるための集中的なマッサージ。',
                        benefits: [
                            '肩の痛みを軽減',
                            '姿勢を改善',
                            '筋肉をリラックス',
                        ],
                    },
                    bodyMassage: {
                        name: 'ボディマッサージ',
                        description: '全体的なリラクゼーションとウェルネスを促進するための全身マッサージ。',
                        benefits: [
                            '血行を改善',
                            '筋肉の痛みを和らげる',
                            'リラクゼーションを促進',
                        ],
                    },
                    backMassage: {
                        name: 'バックマッサージ',
                        description: '背中の痛みと緊張をターゲットにした治療的マッサージ。',
                        benefits: [
                            '背中の痛みを軽減',
                            '脊椎の健康を改善',
                            'ストレスを軽減',
                        ],
                    },
                    footMassage: {
                        name: 'フットマッサージ',
                        description: '足の痛みを和らげ、リラクゼーションを促進するための心地よいマッサージ。',
                        benefits: [
                            '血行を改善',
                            '足の疲労を軽減',
                            'リラクゼーションを促進',
                        ],
                    },
                },
            },
            packagesSection: {
                title: '私たちのパッケージ',
                loadingMessage: 'パッケージを読み込んでいます...',
                errorMessage: 'パッケージの読み込みに失敗しました。後でもう一度お試しください。',
                viewDetails: '詳細を見る',
                bookNow: 'WhatsAppで予約',
                descriptionTitle: '説明',
                featuresTitle: '特徴',
                imageAlt: '{packageName}パッケージの画像',
                modalContentLabel: 'パッケージ詳細',
                closeModal: '閉じる',
                bookNowMessage: 'こんにちは！{packageName}パッケージを予約したいです。\n\nパッケージ詳細：\n{description}\n\n特徴：\n{features}',
            },
            footerSection: {
                logoAlt: 'サンフラワービーチリゾートのロゴ',
                resortTitle: 'サンフラワービーチリゾート',
                links: {
                    home: 'ホーム',
                    aboutUs: '私たちについて',
                    resort: 'リゾート',
                    ayurvedaWellness: 'アーユルヴェーダウェルネス',
                    packages: 'パッケージ',
                    contactUs: 'お問い合わせ',
                },
                getInTouchTitle: 'お問い合わせ',
                address: 'スリランカ、ベルワラ、ポリスバンガローロード6番地',
                email: 'sunflower.beruwala@gmail.com',
                phone: '+94 77 534 0670',
                stayConnectedTitle: 'つながりを保つ',
                emailPlaceholder: 'メールアドレスを入力',
                socialMedia: {
                    facebook: 'Facebookでフォロー',
                    instagram: 'Instagramでフォロー',
                    youtube: 'YouTubeでフォロー',
                    twitter: 'Twitterでフォロー',
                },
                copyright: '© 2025 サンフラワービーチリゾート。全権利予約。',
                developedBy: {
                    text: 'ウェブサイトはRedev Solutionsによって設計および開発されました',
                    phone: '+94 76 460 8225',
                },
            },
        },
    },
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: 'en', // Default language
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;